import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useWeb3React } from "@web3-react/core";
import { Web3AuthNoModal } from "@web3auth/no-modal";
import { EthereumPrivateKeyProvider } from "@web3auth/ethereum-provider";
import { WALLET_ADAPTERS, CHAIN_NAMESPACES } from "@web3auth/base";
import { OpenloginAdapter } from "@web3auth/openlogin-adapter";
import RPC from "./evm.ethers.ts";

import "../../../../splash_event.css";
import { updateLocation, signupLoading } from "../../../../../../../redux/App/actions";
import { setUserSignOn, setLoginWallet } from "../../../../../../../redux/Account/actions";
import {axiosInstance, encryptLoginData, getIndexerUserTokens, closeAllModals} from "../../../../../../../utils";
import {RewardsTransferBox} from "../../../../../../Organisms"

import {genetic_tooltip, genetic_max_tooltip, genetic_track_tooltip, genetic_tooltip_wtrack, genetic_max_tooltip_wtrack} from "./race_landing_tooltips";
import {laps_tooltip, turns_tooltip, straights_tooltip, shifts_tooltip} from "./race_landing_tooltips";

import axios from "axios";
import $ from "jquery";
import LogRocket from 'logrocket';

let current_user_id = 0;
let race_data = [];
let racer_details_global = [];
let current_racer_global = 0;
let firstpickracerid = 0;
let firstpickpartracerid = 0;
let lastpickracerid = 0;
let lastpickpartracerid = 0;
let total_page_results = 15;
let current_race_collection = 7;
let collectionList = [];
let leaderboardList = [];
let finalLeaderboardNum = -1;
let finalUserPosition = [];

export const TrackMeetsResults = () => {
    const dispatch = useDispatch();
    const { page_loaded }= useSelector((state) => state.app);
    const { racerID, userID, accountAddress } = useSelector((state) => state.account);

    const { chainId, account } = useWeb3React();

    // if((racerID.length > 1)&&(accountAddress.length > 1)) {
    //     //
    // }

    const [pageSet, setPage] = useState(false);
    const [web3auth, setWeb3auth] = useState(null);
    const [provider, setProvider] = useState(null);
    const [loggedIn, setLoggedIn] = useState(false);
    const [email, setEmail] = useState("");
    const [customLeaderboardHTML, setCustomLeaderboardHTML] = useState('');
    const [rewardsTransferBoxHTML, setRewardsTransferBoxHTML] = useState('');
    const [rewardWalletName, setRewardWalletName] = useState('');
    const [rewardWalletAddress, setRewardWalletAddress] = useState('');
    const [rewardTransferBoxMedia, setRewardTransferBoxMedia] = useState('');
    const [rewardTransferHiddenVars, setRewardTransferHiddenVars] = useState('');
    const [racePicksHTML,setRacePicksHTML] = useState([]);

    let bg_image_side = 'https://media.exiledracers.com/assets/banners/Banner_Serf_Cinematic1.jpeg';
    let bg_image = 'https://media.exiledracers.com/assets/game/builder/Splash_Background_-_Serf_Centered_1_1665676555319.jpeg';

    bg_image = 'https://media.exiledracers.com/assets/banners/race_background_midj_2.jpeg';
    var bg_image_blurred = 'https://media.exiledracers.com/assets/banners/exr_track_meets_blurred_dj.jpg';
    let logo_image = 'https://media.exiledracers.com/global/exr_logo_white_stacked.png';
    let logomark_image = 'https://media.exiledracers.com/assets/game/builder/EXR_Logomark_White_1693422646590.png';
    let polka_logo = 'https://media.exiledracers.com/assets/game/builder/Polkadot_White_Icon_1693419269508.png';
    let ztg_logo = 'https://media.exiledracers.com/assets/game/builder/Zeitgeist_White_Icon_1693419306813.png';
    let moonbeam_logo = 'https://media.exiledracers.com/assets/game/builder/Moonbeam_White_Icon_1693419281943.png';
    let exr_wordmark = 'https://media.exiledracers.com/assets/game/builder/EXR_Wordmark_Long_1693420169042.png';

    const bot_pilots = ['https://media.exiledracers.com/assets/bots/PILOT_AUGMENT_BOT.png',
    'https://media.exiledracers.com/assets/bots/PILOT_MERCENARY_BOT.png',
    'https://media.exiledracers.com/assets/bots/PILOT_SERF_BOT.png'];

    /* EXR Event ID */
    var exreventid = 1;
    let signup_user_id = 0;
    let race_array = [16604,16605,16606];
    var race_id = race_array[0];
    var race_unique_id = 'Ye43O7tHly';
    var pred_racer_id = 0;
    var pred_participant_id = 0;
    var pred_participant_id = 0;
    var free_pred_amount = 0;

    
    function validateEmailText(emailtext) {
        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
        if (emailtext.match(validRegex)) {
          return 'pass';
        } else {
          return 'fail';
        }
    }

    function sendEventEmailCode() {
        var raceremail = document.getElementById("racerEmailAddress").value.trim();

        var addData = new Object();
        addData.specEmail = encodeURIComponent(raceremail);

        if(raceremail.length < 3) {
            alert('Add a Valid Email Address');
        } else if (validateEmailText(raceremail) == 'fail') {
            alert('Add a Valid Email Address');
        } else {
            $("#email-send-button").hide();
            $("#email-sent-loading").show();
            if(userID > 0) {
                showEmailLoggedIn();
                // Create or Get Web3Auth Info
                //loginWeb3Auth(raceremail);
            } else {
                axiosInstance.post('member/event_email_add/',addData).then(result => {
                    if(Object.keys(result.data).length > 0) {
                        var save_result = result.data;
                        if(save_result.length > 0) {
                            //console.log('Email Data Added');
                            showEmailSendSent();
                        } else {
                            //console.log('No Email Data Found');
                            showEmailSendReset();
                            alert('Whoops! Something Went Wrong. Update and Try Again');
                        }
                        // Create or Get Web3Auth Info
                        //loginWeb3Auth(raceremail);
                    } else {
                        //console.log('Email Add No Data');
                        showEmailSendReset();
                        alert('Something Went Wrong. Update and Try Again.');
                    }
                }).catch(error => {
                    showEmailSendReset();
                    alert('Oh No! Something Went Wrong. Update and Try Again.');
                    console.log(error);
                });
            }
        }
    }

    function checkEventEmailCode() {
        var raceremail = document.getElementById("racerEmailAddress").value.trim();
        var racercode = document.getElementById("racerEmailCode").value.trim();
        
        var addData = new Object();
        addData.specEmail = encodeURIComponent(raceremail);
        addData.specCode = encodeURIComponent(racercode);
        addData.specEvent = encodeURIComponent(exreventid);

        if(raceremail.length <= 3) {
            alert('Add a Valid Email Address');
        } else if (validateEmailText(raceremail) == 'fail') {
            alert('Add a Valid Email Address');
        } else if (racercode.length != 6) {
            alert('Add a Valid Email Code');
        } else {
            $("#code-send-button").hide();
            $("#code-confirmed-loading").show();
            axiosInstance.post('member/event_email_code_check/',addData).then(result => {
                if(Object.keys(result.data).length > 0) {
                    var save_result = result.data;
                    if(save_result.length > 0) {
                        if(save_result[0]['status'] == 'expired') {
                            showEmailCodeReset();
                            alert('Your Confirmation Code Expired. Click Resend Code to Get a New Code.');
                            //console.log('Your Confirmation Code Expired. Click Resend Code to Get a New Code.');
                        } else if(save_result[0]['status'] == 'pending') {
                            showEmailCodeReset();
                            alert('Invalid Code. Check Your Code and Enter it Again');
                            //console.log('Invalid Code. Check Your Code and Enter it Again');
                        } else if (save_result[0]['status'] == 'approved_waitroom') {
                            // New User - Add to Users Table
                            addSpectatorInfo();

                        } else {
                            // Existing User - Approve Code
                            let userid = save_result[0]['user_id'];
                            let racerid = save_result[0]['racer_id'];
                            let spectatorid = save_result[0]['spectator_id'];
                            let logintime = save_result[0]['time'];
                            let logintoken = save_result[0]['token'];
                            // let logintimehash = save_result[0]['time_hash'];
                            // let hashed_time = encryptLoginData('login',logintime.toString());

                            // Login to Site
                            current_user_id = userid;
                            signup_user_id = userid;
                            dispatch(setUserSignOn(userid,racerid,spectatorid,logintoken,logintime));

                            // Existing User - Approve Code
                            showEmailCodeApproved();
                            
                            // Create or Get Web3Auth Info
                            //loginWeb3Auth(raceremail);
                        }
                    } else {
                        showEmailCodeReset();
                        alert('Whoops! Something Went Wrong. Update and Try Again');
                        //console.log('Whoops! Something Went Wrong. Update and Try Again');
                    }
                }
            }).catch(error => {
                console.log(error);
            });
        }
    }

    function addSpectatorInfo() {
        var raceremail = document.getElementById("racerEmailAddress").value.trim();
        var racerhandle = '';
        var racertwitter = ''
        var racerdiscord = ''
        var addData = new Object();
        addData.specEmail = encodeURIComponent(raceremail);
        addData.specHandle = encodeURIComponent(racerhandle);
        addData.specTwitter = encodeURIComponent(racertwitter);
        addData.specDiscord = encodeURIComponent(racerdiscord);
        addData.specSource = 'event';
        addData.specEvent = encodeURIComponent(exreventid);

        axiosInstance.post('member/waitroom_spectator_add/',addData).then(result => {
            if(Object.keys(result.data).length > 0) {
                var save_result = result.data;
                if(save_result.length > 0) {
                    let userid = save_result[0]['user_id'];
                    let racerid = save_result[0]['racer_id'];
                    let spectatorid = save_result[0]['spectator_id'];
                    let logintime = save_result[0]['time'];
                    let logintoken = save_result[0]['token'];
                    // let logintimehash = save_result[0]['time_hash'];
                    // let hashed_time = encryptLoginData('login',logintime.toString());

                    // Login to Site
                    current_user_id = userid;
                    signup_user_id = userid;
                    dispatch(setUserSignOn(userid,racerid,spectatorid,logintoken,logintime));
                    
                    // New User Added - Approve Code
                    showEmailCodeApproved();

                    // Create or Get Web3Auth Info
                    //loginWeb3Auth(raceremail);

                } else {
                    showEmailCodeReset();
                    alert('Whoops! Something Went Wrong. Update and Try Again');
                }
            }
        }).catch(error => {
            console.log(error);
        });
    }

    function grabRaceParticipantsLoop() {
        race_data = [];
        grabRaceParticipantsData(1,race_array[0]);
    }

    function grabRaceParticipantsData(racenum,raceid) {
        var addData = new Object();
        addData.raceID = encodeURIComponent(raceid);
        addData.predictorID = current_user_id;
        addData.sortBY = 'standings_event';

        axiosInstance.post('race/prediction_list/',addData).then(result => {
            if(Object.keys(result.data).length > 0) {
                var racer_list = result.data;
                var current_racer_status = {};

            }
            var newracelist = {};
            newracelist['race_id'] = raceid;
            newracelist['race_number'] = racenum;
            newracelist['racers'] = result.data;
            race_data.push(newracelist);
            if(racenum == race_array.length) {
                loadRaceResults();
            } else {
                grabRaceParticipantsData(racenum+1,race_array[racenum]);
            } 
        }).catch(error => {
            console.log(error);
        });
    }


    function loadRaceResults() {
        var placenum = 1;
        var lastplacenum = 5;
        var allraces = [];
        for(var k = 0; k < race_data.length;k++) {
            var racer_details = race_data[k]['racers'];
            var race_number = race_data[k]['race_number'];
            var lineuphtml = [];
            // for(var i = 0; i < racer_details.length;i++) {
            //     var racername = racer_details[i]['racer_name'];
            //     pred_racer_id = racer_details[i]['racer_id'];
            //     pred_participant_id = racer_details[i]['race_participant_id'];
            //     var racershipphoto = racer_details[i]['ship_image_location'];
            //     var start_win = Math.floor((racer_details[i]['racer_start_win_pct']*100)/5)*5;
            //     var start_odds = (100-start_win)/10;
            //     var odds_points = (100-start_win);
            //     start_odds = Math.floor(racer_details[i]['racer_start_win_pct']*100);
            //     odds_points = 100-Math.floor(racer_details[i]['racer_start_win_pct']*100);
                
            //     var user_predicted = racer_details[i]['racer_predicted'];
            //     var user_predicted_place = racer_details[i]['racer_predicted_place'];
            //     var buttontext = 'PREDICT 1ST PLACE';
            //     var buttoncolors = 'white black-text';
            //     var winsubtext = 'chance to win';
            //     var overlayshow = 'none';
            //     var overlayplace = '1ST';
            //     if(user_predicted_place == lastplacenum) {
            //         var invertednum = racer_details.length-1-i;
            //         start_odds = Math.floor(racer_details[invertednum]['racer_start_win_pct']*100);
            //         odds_points = Math.floor((100-start_odds)/2);
            //         winsubtext = 'to come last';
            //         overlayplace = 'LAST';
            //     }

            //     var user_predicted_this = 0;
            //     if((user_predicted == 1)&&(placenum == user_predicted_place)) {
            //         user_predicted_this = 1;
            //         overlayshow = 'block';
            //     }

            //     if((user_predicted == 1)&&(lastplacenum == 5)&&(lastplacenum == user_predicted_place)) {
            //         buttontext = 'PREDICTED LAST PLACE';
            //         buttoncolors = 'grey white-text';
            //         lastpickracerid = pred_racer_id;
            //         lastpickpartracerid = pred_participant_id;
            //         setLastPickName(racername);
            //         setLastPickPhoto(racershipphoto);
            //         setLastPickPoints(odds_points);
            //         setLastPickOdds(start_odds);

            //     } else if((user_predicted == 1)&&(placenum == 1)&&(placenum == user_predicted_place)) {
            //         buttontext = 'PREDICTED 1ST PLACE';
            //         buttoncolors = 'grey white-text';
            //         firstpickracerid = pred_racer_id;
            //         firstpickpartracerid = pred_participant_id;
            //         setFirstPickName(racername);
            //         setFirstPickPhoto(racershipphoto);
            //         setFirstPickPoints(odds_points);
            //         setFirstPickOdds(start_odds);

            //     } else if(placenum == 5) {
            //         buttontext = 'PREDICT LAST PLACE';
            //     }

            //     var tmphtml = <div key={"pred"+placenum+"block"+pred_racer_id+"selected"+user_predicted_this} className="col s12 l4" style={{margin:'0px',padding:'0px'}}>
            //                         <div className="left" style={{width:'100%',padding:'20px'}}>
            //                             <div className="row headline-text left-align" style={{fontSize:'14px',padding:'0px'}}>
            //                                 {racername.toUpperCase()}
            //                             </div>
            //                             <div className="row overlaymainphoto" style={{position:'relative',padding:'0px'}}>
            //                                 <img src={racershipphoto} style={{width:'100%',borderRadius:'5px'}} />
            //                                 <div id={"overlay"+placenum+"back"+pred_racer_id} className={"predoverlay"+placenum+" exr-trans-black-bg"} style={{display:overlayshow,position:'absolute',width:'100%',height:'100%',zIndex:'15',top:'0px',left:'0px'}}></div>
            //                                 <div id={"overlay"+placenum+"text"+pred_racer_id} className={"predoverlay"+placenum+" center-align"} style={{display:overlayshow,position:'absolute',width:'100%',zIndex:'17',top:'35%',left:'0px',fontSize:'18px'}}>
            //                                     <div className="exr-red-text headline-text">
            //                                         {overlayplace} PLACE PICK
            //                                     </div>
            //                                     <div className="exr-red-text subheadline-text-mono">
            //                                         POINTS: {odds_points}
            //                                     </div>
            //                                 </div>
            //                             </div>
            //                             <div className="overlaysubinfo row subheadline-text-mono" style={{fontSize:'14px',height:'100px',display:'flex',flexDirection:'row',position:'relative'}}>
            //                                 <div className="overlaysubinfophoto" style={{float:'left',height:'100px',padding:'5px'}}>
            //                                     <img src={racershipphoto} style={{height:'100%',borderRadius:'5px'}} />
            //                                 </div>
            //                                 <div className="overlaysubinfotext" style={{float:'left', flex:'1'}}>
            //                                     <div className="left subheadline-text-mono section-triple-subtext" style={{width:'100%',marginBottom:'10px',fontSize:'12px',padding:'0px'}}>
            //                                         {start_odds}% {winsubtext} //<br />
            //                                         {odds_points} points if correct
            //                                     </div>
            //                                 </div>
            //                             </div>
            //                         </div>
            //                     </div>;
            //     lineuphtml.push(tmphtml);



                var racer_handle_arr = [];
        var racerrows = [];
        var tmp_racer_rows = [];
        var predict_last_place = 1;

        var predicted_racer_id = 0;
        var predicted_racer_id_last = 0;
        var firstpickname = 'None';
        var lastpickname = 'None';
        var firstpoints = 0;
        var lastpoints = 0;
        var firstresult = <>First Pick</>;
        var lastresult = <>Last Pick</>;
        for (var i = 0; i < racer_details.length; i++) {
            var pracerid_check = racer_details[i]['racer_id'];
            var user_predicted_check = racer_details[i]['racer_predicted'];
            var user_predicted_place = racer_details[i]['racer_predicted_place'];
            
            if(user_predicted_check == 1) {
                if(user_predicted_place == 1) {
                    predicted_racer_id = pracerid_check;
                    firstpickname = racer_details[i]['racer_name'];
                    if(racer_details[i]['racer_predicted_result_show'] == 1) {
                        if(racer_details[i]['racer_predicted_win'] == 1) {
                            firstresult = <>First Pick // <span className="exr-light-green-text">Correct</span></>;
                        } else {
                            firstresult = <>First Pick // <span className="exr-light-orange-text">Missed</span></>;
                        }
                    }
                } else if(user_predicted_place == 5) {
                    predicted_racer_id_last = pracerid_check;
                    lastpickname = racer_details[i]['racer_name'];
                    if(racer_details[i]['racer_predicted_result_show'] == 1) {
                        if(racer_details[i]['racer_predicted_win'] == 1) {
                            lastresult = <>Last Pick // <span className="exr-light-green-text">Correct</span></>;
                        } else {
                            lastresult = <>Last Pick // <span className="exr-light-orange-text">Missed</span></>;
                        }
                    }
                    
                }
            }
        }

        if(predict_last_place == 1) {
            var additionalpredinstructions = <div key={"racewaypredictrowinstructions"} className="row exr-new-dark-grey" style={{margin:'0px',marginBottom:'10px',width:'100%',borderRadius:'10px',padding:'7px 5px',overflow:'hidden'}}>
            <div className="left" style={{flex:'1',marginLeft:'10px',position:'relative',marginTop:'2px'}}>
                PREDICT <span className="exr-yellow-text">1ST PLACE</span> AND <span className="exr-yellow-text">LAST PLACE</span>
            </div>
            </div>;
            tmp_racer_rows.push(additionalpredinstructions);
        }


        for (var i = 0; i < racer_details.length; i++) {
            racer_handle_arr.push(racer_details[i]['racer_name']);
            var total_xp_points = 100;
            var userid = racer_details[i]['user_id'];
            var raceid = racer_details[i]['race_id'];
            var pracerid = racer_details[i]['racer_id'];
            var racername = racer_details[i]['racer_name'].toUpperCase();
            var pilot_image = racer_details[i]['pilot_image_location'];
            var racecraft_image = racer_details[i]['ship_image_location'];
            var user_predicted = racer_details[i]['racer_predicted'];
            var win_pct = Math.floor(racer_details[i]['racer_start_win_pct']*100);
            var xpchance = Math.round(total_xp_points*(1-(racer_details[i]['racer_start_win_pct'])));
            var xpchancelast = Math.round(xpchance / 2);
            var totalpreds = racer_details[i]['total_predictors'];
            var pilot_image_bg = "url('"+pilot_image+"')";
            var margintop = "0px 0px 8px 0px";

            var racer_name = racer_details[i].racer_name;
            var racer_bot_racer = racer_details[i].bot_racer;
            var race_track_faction = racer_details[i].race_track_galaxy;
            
            var score_speed = 0;
            var score_handling = 0;
            var score_acceleration = 0;
            var score_strength = 0;
            var score_focus = 0;
            var score_stamina = 0;
            var score_intelligence = 0;
            var score_aggression = 0;
            var score_speed2 = 0;
            var score_handling2 = 0;
            var score_acceleration2 = 0;
            var score_strength2 = 0;
            var score_focus2 = 0;
            var score_stamina2 = 0;
            var score_intelligence2 = 0;
            var score_aggression2 = 0;
            var score_handling3 = 0;
            var score_focus3 = 0;
            var score_speed3 = 0;
            var score_intelligence3 = 0;

            /* If Bot Racer, Then Use Override Attribute Stats and Booster Stats */
            if(racer_bot_racer == 1) {
                for(var m = 0; m < racer_details[i].override_attributes.length;m++) {
                    racer_details[i].override_attributes[m].attribute = racer_details[i].override_attributes[m].attribute.toLowerCase();
                    if(racer_details[i].override_attributes[m].attribute == 'speed') {
                        score_speed = racer_details[i].override_attributes[m].score;
                    } else if(racer_details[i].override_attributes[m].attribute == 'handling') {
                        score_handling = racer_details[i].override_attributes[m].score;
                    } else if(racer_details[i].override_attributes[m].attribute == 'acceleration') {
                        score_acceleration = racer_details[i].override_attributes[m].score;
                    } else if(racer_details[i].override_attributes[m].attribute == 'strength') {
                        score_strength = racer_details[i].override_attributes[m].score;
                    } else if(racer_details[i].override_attributes[m].attribute == 'focus') {
                        score_focus = racer_details[i].override_attributes[m].score;
                    } else if(racer_details[i].override_attributes[m].attribute == 'stamina') {
                        score_stamina = racer_details[i].override_attributes[m].score;
                    } else if(racer_details[i].override_attributes[m].attribute == 'aggression') {
                        score_aggression = racer_details[i].override_attributes[m].score;
                    } else if(racer_details[i].override_attributes[m].attribute == 'intelligence') {
                        score_intelligence = racer_details[i].override_attributes[m].score;
                    } 
                }

                var booster_attribute_score = racer_details[i].boosters[9];
                var booster_attribute_name = racer_details[i].boosters[4].toLowerCase();
                if(booster_attribute_name == 'focus') {
                    score_focus2 = booster_attribute_score;
                } else if(booster_attribute_name == 'stamina') {
                    score_stamina2 = booster_attribute_score;
                } else if(booster_attribute_name == 'aggression') {
                    score_aggression2 = booster_attribute_score;
                } else if(booster_attribute_name == 'intelligence') {
                    score_intelligence2 = booster_attribute_score;
                } else if(booster_attribute_name == 'speed') {
                    score_speed2 = booster_attribute_score;
                } else if(booster_attribute_name == 'handling') {
                    score_handling2 = booster_attribute_score;
                } else if(booster_attribute_name == 'acceleration') {
                    score_acceleration2 = booster_attribute_score;
                }  else if(booster_attribute_name == 'strength') {
                    score_strength2 = booster_attribute_score;
                } 

            } else {
                
                for(var m = 0; m < racer_details[i].ship_attributes.length;m++) {
                    racer_details[i].ship_attributes[m].attribute = racer_details[i].ship_attributes[m].attribute.toLowerCase();

                    if(racer_details[i].ship_attributes[m].attribute == 'speed') {
                        score_speed = racer_details[i].ship_attributes[m].score;
                    } else if(racer_details[i].ship_attributes[m].attribute == 'handling') {
                        score_handling = racer_details[i].ship_attributes[m].score;
                    } else if(racer_details[i].ship_attributes[m].attribute == 'acceleration') {
                        score_acceleration = racer_details[i].ship_attributes[m].score;
                    }  else if(racer_details[i].ship_attributes[m].attribute == 'strength') {
                        score_strength = racer_details[i].ship_attributes[m].score;
                    } 
                }

                for(var m = 0; m < racer_details[i].pilot_attributes.length;m++) {
                    racer_details[i].pilot_attributes[m].attribute = racer_details[i].pilot_attributes[m].attribute.toLowerCase();
                    
                    if(racer_details[i].pilot_attributes[m].attribute == 'focus') {
                        score_focus = racer_details[i].pilot_attributes[m].score;
                    } else if(racer_details[i].pilot_attributes[m].attribute == 'stamina') {
                        score_stamina = racer_details[i].pilot_attributes[m].score;
                    } else if(racer_details[i].pilot_attributes[m].attribute == 'aggression') {
                        score_aggression = racer_details[i].pilot_attributes[m].score;
                    } else if(racer_details[i].pilot_attributes[m].attribute == 'intelligence') {
                        score_intelligence = racer_details[i].pilot_attributes[m].score;
                    } 
                }
                
                var booster_attributes = racer_details[i].boosters[8];
                if(booster_attributes != null) {
                    for(var m = 0; m < booster_attributes.length;m++) {
                        booster_attributes[m].attribute = booster_attributes[m].attribute.toLowerCase();
                        if(booster_attributes[m].attribute == 'focus') {
                            score_focus2 = booster_attributes[m].score;
                        } else if(booster_attributes[m].attribute == 'stamina') {
                            score_stamina2 = booster_attributes[m].score;
                        } else if(booster_attributes[m].attribute == 'aggression') {
                            score_aggression2 = booster_attributes[m].score;
                        } else if(booster_attributes[m].attribute == 'intelligence') {
                            score_intelligence2 = booster_attributes[m].score;
                        } else if(booster_attributes[m].attribute == 'speed') {
                            score_speed2 = booster_attributes[m].score;
                        } else if(booster_attributes[m].attribute == 'handling') {
                            score_handling2 = booster_attributes[m].score;
                        } else if(booster_attributes[m].attribute == 'acceleration') {
                            score_acceleration2 = booster_attributes[m].score;
                        }  else if(booster_attributes[m].attribute == 'strength') {
                            score_strength2 = booster_attributes[m].score;
                        } 
                    }
                }
                
            }

            var genetic_boost_text = <></>;
            var track_faction_pilot_match = 0;
            var track_faction_racecraft_match = 0;
            if(racer_details[i].pilot_faction.toLowerCase() == race_track_faction.toLowerCase()) {
                track_faction_pilot_match = 1;
                score_intelligence3 = 2;
            }
            if(racer_details[i].ship_faction.toLowerCase() == race_track_faction.toLowerCase()) {
                track_faction_racecraft_match = 1;
                score_speed3 = 2;
            }
            if(racer_details[i].boosters[5] == null) {
                racer_details[i].boosters[5] = '';
            }

            if((racer_details[i].pilot_faction.toLowerCase() == racer_details[i].ship_faction.toLowerCase())&&
                (((racer_details[i].pilot_faction.toLowerCase() == racer_details[i].boosters[5].toLowerCase())||(racer_details[i].boosters[5].toLowerCase() == 'any'))||
                    (race_track_faction.toLowerCase() == racer_details[i].pilot_faction.toLowerCase()))) {
                score_handling3 = 4;
                score_focus3 = 4;
                var finalboosttip = genetic_max_tooltip;
                if ((track_faction_pilot_match > 0)||(track_faction_racecraft_match > 0)) {
                    finalboosttip = genetic_max_tooltip_wtrack;
                }
                genetic_boost_text = <span className="right exr-yellow-text lineuptips" style={{marginRight:'15px',cursor:'context-menu'}} data-position="bottom" data-tooltip={finalboosttip}>GENETIC MAX</span>;
            } else if(racer_details[i].pilot_faction.toLowerCase() == racer_details[i].ship_faction.toLowerCase()) {
                score_handling3 = 3;
                score_focus3 = 3;
                var finalboosttip = genetic_tooltip;
                if ((track_faction_pilot_match > 0)||(track_faction_racecraft_match > 0)) {
                    finalboosttip = genetic_tooltip_wtrack;
                }
                genetic_boost_text = <span className="right exr-yellow-text lineuptips" style={{marginRight:'15px',cursor:'context-menu'}} data-position="bottom" data-tooltip={finalboosttip}>GENETIC BOOST</span>;
            } else if ((track_faction_pilot_match > 0)||(track_faction_racecraft_match > 0)) {
                genetic_boost_text = <span className="right exr-yellow-text lineuptips" style={{marginRight:'15px',cursor:'context-menu'}} data-position="bottom" data-tooltip={genetic_track_tooltip}>GENETIC TRACK</span>;
            }
            var pstatusbutton = 'A';
            var buttonpredicteddisp = 'none';
            var buttonchangedisp = 'none';
            var buttondonedisp = 'none';
            var buttonpredictdisp = 'none';
            var buttonnumdisp = 'none';

            var predictbutton = <></>;
            var predictedfinish = 0;
            var predictedbuttontxt = 'PREDICTED';
            var changebuttontxt = 'CHANGE PICK';
            var donebuttontext = 'PICKS DONE';
            
            var xptext = <></>;
            if(user_predicted == 1) {
                buttonpredicteddisp = 'block';
                pstatusbutton = 'S';
                predictbutton = <div className="right round-border-button-green viewer-racer-pred-button" 
                        style={{fontSize:'0.4vw',minHeight:'1.15vw'}} key={"racewaypredictbutton"+raceid+pracerid+pstatusbutton}
                        title="Predicted"
                        >PREDICTED</div>;

                predictedfinish = racer_details[i]['racer_predicted_place'];
                if(predict_last_place == 1) {
                    if(racer_details[i]['racer_predicted_place'] == 5) {
                        predictedbuttontxt = 'PICKED LAST';
                        xptext = <><span style={{fontSize:'16px'}}>{xpchancelast}</span>&nbsp;&nbsp;XP</>;
                    } else if (racer_details[i]['racer_predicted_place'] == 1) {
                        predictedbuttontxt = 'PICKED 1ST';
                        xptext = <><span style={{fontSize:'16px'}}>{xpchance}</span>&nbsp;&nbsp;XP</>;
                    }
                }
                
            } else {
                buttonnumdisp = 'block';
                predictbutton = <div key={"racewaypredictbutton"+raceid+pracerid+pstatusbutton} className="right" style={{fontSize:'14px',minHeight:'1.15vw',marginTop:'2px',marginRight:'5px'}}>RACER {i+1}</div>;
            }

            var final_race_position = <>{i+1}</>;

            var allpredictbuttons = <><div className="right exr-light-green-text" 
                                            style={{fontSize:'12px',marginRight:'10px',minHeight:'1.15vw',display:buttonpredicteddisp}} key={"racewaypredictbutton"+raceid+pracerid+'S'}
                                            title="Predicted"
                                        >{predictedbuttontxt}</div>
                                        </>;

            var score_html = <div className="col s12 white-text" style={{fontSize:'14px'}}>
                                <div className="row headline-text" style={{marginTop:'0px',marginBottom:'0px',padding:'0px',position:'relative',fontSize:'12px'}}>
                                    <span className="left white-green-link" title="Learn About Racing Stacks" style={{marginLeft:'15px'}}>
                                        RACE STACK
                                    </span>
                                    {genetic_boost_text}
                                </div>
                                <div className="divider-thin"></div>
                                <div className="row" style={{marginTop:'15px',marginBottom:'5px'}}>
                                        <div className="col s6">
                                            <div className="row" style={{marginTop:'5px',marginBottom:'5px'}}>
                                            <div className="col s12">
                                                <div style={{width:'100%',textAlign:'right',fontSize:'12px',marginBottom:'0px'}}>
                                                    <div className="left">Speed</div>
                                                    <div className="right">{(score_speed+score_speed2+score_speed3)}</div>
                                                </div>
                                                <div style={{width:'100%'}}>
                                                    <div className="progress exr-stats-light-grey" style={{borderRadius:'3px',height:'5px',marginTop:'2px'}}>
                                                        <div className="determinate white left" style={{width:score_speed+'%'}}></div>
                                                        <div className="determinate exr-stats-light-green2 left" title="Attribute Booster" style={{width:score_speed2+'%',left:score_speed+'%'}}></div>
                                                        <div className="determinate exr-stats-yellow left" title="Genetic Track Booster" style={{width:score_speed3+'%',left:(score_speed+score_speed2)+'%'}}></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row" style={{marginTop:'5px',marginBottom:'5px'}}>
                                            <div className="col s12">
                                                <div style={{width:'100%',textAlign:'right',fontSize:'12px',marginBottom:'0px'}}>
                                                    <div className="left">Handling</div>
                                                    <div className="right">{(score_handling+score_handling2+score_handling3)}</div>
                                                </div>
                                                <div style={{width:'100%'}}>
                                                    <div className="progress exr-stats-light-grey" style={{borderRadius:'3px',height:'5px',marginTop:'2px'}}>
                                                        <div className="determinate white left" style={{width:score_handling+'%'}}></div>
                                                        <div className="determinate exr-stats-light-green2 left" title="Attribute Booster" style={{width:score_handling2+'%',left:score_handling+'%'}}></div>
                                                        <div className="determinate exr-stats-yellow left" title="Genetic Booster" style={{width:score_handling3+'%',left:(score_handling+score_handling2)+'%'}}></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row" style={{marginTop:'5px',marginBottom:'5px'}}>
                                            <div className="col s12">
                                                <div style={{width:'100%',textAlign:'right',fontSize:'12px',marginBottom:'0px'}}>
                                                    <div className="left">Acceleration</div>
                                                    <div className="right">{(score_acceleration+score_acceleration2)}</div>
                                                </div>
                                                <div style={{width:'100%'}}>
                                                    <div className="progress exr-stats-light-grey" style={{borderRadius:'3px',height:'5px',marginTop:'2px'}}>
                                                        <div className="determinate white left" style={{width:score_acceleration+'%'}}></div>
                                                        <div className="determinate exr-stats-light-green2 left" title="Attribute Booster" style={{width:score_acceleration2+'%',left:score_acceleration+'%'}}></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row" style={{marginTop:'5px',marginBottom:'5px'}}>
                                            <div className="col s12">
                                                <div style={{width:'100%',textAlign:'right',fontSize:'12px',marginBottom:'0px'}}>
                                                    <div className="left">Strength</div>
                                                    <div className="right">{(score_strength+score_strength2)}</div>
                                                </div>
                                                <div style={{width:'100%'}}>
                                                    <div className="progress exr-stats-light-grey" style={{borderRadius:'3px',height:'5px',marginTop:'2px'}}>
                                                        <div className="determinate white left" style={{width:score_strength+'%'}}></div>
                                                        <div className="determinate exr-stats-light-green2 left" title="Attribute Booster" style={{width:score_strength2+'%',left:score_strength+'%'}}></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div className="col s6">
                                        <div className="row" style={{marginTop:'5px',marginBottom:'5px'}}>
                                            <div className="col s12">
                                                <div style={{width:'100%',textAlign:'right',fontSize:'12px',marginBottom:'0px'}}>
                                                    <div className="left">Focus</div>
                                                    <div className="right">{(score_focus+score_focus2+score_focus3)}</div>
                                                </div>
                                                <div style={{width:'100%'}}>
                                                    <div className="progress exr-stats-light-grey" style={{borderRadius:'3px',height:'5px',marginTop:'2px'}}>
                                                        <div className="determinate white left" style={{width:score_focus+'%'}}></div>
                                                        <div className="determinate exr-stats-light-green2 left" title="Attribute Booster" style={{width:score_focus2+'%',left:score_focus+'%'}}></div>
                                                        <div className="determinate exr-stats-yellow left" title="Genetic Booster" style={{width:score_focus3+'%',left:(score_focus+score_focus2)+'%'}}></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row" style={{marginTop:'5px',marginBottom:'5px'}}>
                                            <div className="col s12">
                                                <div style={{width:'100%',textAlign:'right',fontSize:'12px',marginBottom:'0px'}}>
                                                    <div className="left">Stamina</div>
                                                    <div className="right">{(score_stamina+score_stamina2)}</div>
                                                </div>
                                                <div style={{width:'100%'}}>
                                                    <div className="progress exr-stats-light-grey" style={{borderRadius:'3px',height:'5px',marginTop:'2px'}}>
                                                        <div className="determinate white left" style={{width:score_stamina+'%'}}></div>
                                                        <div className="determinate exr-stats-light-green2 left" title="Attribute Booster" style={{width:score_stamina2+'%',left:score_stamina+'%'}}></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row" style={{marginTop:'5px',marginBottom:'5px'}}>
                                            <div className="col s12">
                                                <div style={{width:'100%',textAlign:'right',fontSize:'12px',marginBottom:'0px'}}>
                                                    <div className="left">Aggression</div>
                                                    <div className="right">{(score_aggression+score_aggression2)}</div>
                                                </div>
                                                <div style={{width:'100%'}}>
                                                    <div className="progress exr-stats-light-grey" style={{borderRadius:'3px',height:'5px',marginTop:'2px'}}>
                                                        <div className="determinate white left" style={{width:score_aggression+'%'}}></div>
                                                        <div className="determinate exr-stats-light-green2 left" title="Attribute Booster" style={{width:score_aggression2+'%',left:score_aggression+'%'}}></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row" style={{marginTop:'5px',marginBottom:'5px'}}>
                                            <div className="col s12">
                                                <div style={{width:'100%',textAlign:'right',fontSize:'12px',marginBottom:'0px'}}>
                                                    <div className="left">Intelligence</div>
                                                    <div className="right">{(score_intelligence+score_intelligence2+score_intelligence3)}</div>
                                                </div>
                                                <div style={{width:'100%'}}>
                                                    <div className="progress exr-stats-light-grey" style={{borderRadius:'3px',height:'5px',marginTop:'2px'}}>
                                                        <div className="determinate white left" style={{width:score_intelligence+'%'}}></div>
                                                        <div className="determinate exr-stats-light-green2 left" title="Attribute Booster" style={{width:score_intelligence2+'%',left:score_intelligence+'%'}}></div>
                                                        <div className="determinate exr-stats-yellow left" title="Genetic Track Booster" style={{width:score_intelligence3+'%',left:(score_intelligence+score_intelligence2)+'%'}}></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>;

            var predict_html = <><div className="left" style={{fontSize:'16px',marginTop:'2px',marginRight:'5px',lineHeight:'1'}}>
                                    {win_pct}%
                                </div>
                                <div className="left" style={{fontSize:'12px',marginTop:'4px',lineHeight:'1'}}>
                                    WIN
                                </div>
                                <div className="left" style={{fontSize:'12px',marginTop:'2px',lineHeight:'1',marginLeft:'25px'}}>
                                    {xptext}
                                </div>
                                <div id={"racer-stack-show-icon-"+pracerid+"race"+race_number} className="right material-symbols-outlined white-text" style={{fontSize:'20px',marginTop:'px',lineHeight:'1'}}>
                                    expand_more
                                </div>
                                <div className="right" style={{fontSize:'12px',marginTop:'5px',lineHeight:'1',marginRight:'0px'}}>
                                    {allpredictbuttons}
                                </div>

                                </>;

                var tmp_row = <div key={"racewaypredictrow"+raceid+pracerid+pstatusbutton} className="row exr-new-dark-grey" style={{margin:'0px',margin:margintop,width:'100%',borderRadius:'10px',padding:'5px',overflow:'hidden'}}>
                                <div id={"racer-row-"+pracerid+"race"+race_number} data-racerrow={pracerid+"race"+race_number} 
                                    onClick={(e)=>toggleRacerRow(e)}
                                    className="row exr-new-light-grey" style={{display:'flex',flexDirection:'row',margin:'0px',padding:'0px 7px',paddingTop:'7px',borderRadius:'10px',cursor:'pointer'}}>
                                    <div className="left" style={{width:'17%',lineHeight:'.5',marginBottom:'7px'}}>
                                        <img src={racecraft_image} width="100%" style={{borderRadius:'5px'}} />
                                    </div>
                                    <div className="left white-text" style={{flex:'1',marginLeft:'10px',position:'relative'}}>
                                        <div className="row headline-text" style={{margin:'0px',fontSize:"14px",marginTop:'5px'}}>
                                            {racername.toUpperCase()}
                                        </div>
                                        <div className="row" style={{margin:'0px',fontSize:"16px",marginTop:'10px'}}>
                                            {predict_html}
                                        </div>
                                        <div className="headline-text" style={{position:'absolute',top:'5px',right:'5px',fontSize:'14px'}}>
                                            {final_race_position}
                                        </div>
                                        <div style={{position:'absolute',bottom:'5px',right:'10px'}}>
                                            
                                        </div>
                                    </div>
                                    
                                </div>
                                <div id={"racer-stack-show-"+pracerid+"race"+race_number} className="row exr-new-light-grey" style={{display:'none',margin:'0px',padding:'5px',marginTop:'-10px',
                                borderRadius:'10px',borderTopRightRadius:'0px',borderTopLeftRadius:'0px'}}>
                                    <div className="col s12 exr-new-dark-grey" style={{padding:"2px",paddingTop:'15px',marginTop:'10px',borderRadius:"10px",height:'auto',marginBottom:'0px'}}>
                                            {score_html}
                                    </div>
                                </div>
                        </div>;

                lineuphtml.push(tmp_row);

            }

            var resultcolhtml = <div key={"raceresults"+race_number} className="col s12 l4" style={{padding:'10px',marginBottom:'30px'}}>
                            <div className="row exr-new-dark-grey" style={{margin:'0px',padding:'10px',borderRadius:'10px'}}>
                                <div className="row white-text" style={{margin:'0px',fontSize:'16px',padding:'0px 5px',marginBottom:'10px'}}>
                                    <div className="row exr-stats-light-grey" style={{margin:'0px',padding:'10px 7px',borderRadius:'10px'}}>
                                        <div className="col s12 headline-text  left-align" style={{fontSize:'16px',marginBottom:'10px',marginTop:'10px'}}>
                                            RACE {race_number}
                                        </div>
                                        <div className="col s6 white-text left-align" style={{fontSize:'16px',position:'relative',marginBottom:'10px'}}>
                                            <div className="row" style={{fontSize:'12px',margin:'0px',marginBottom:'5px'}}>
                                                {firstresult}
                                            </div>
                                            <div className="row" style={{margin:'0px'}}>{firstpickname}</div>
                                            
                                        </div>
                                        <div className="col s6 white-text left-align" style={{fontSize:'16px',position:'relative',marginBottom:'10px'}}>
                                            <div className="row" style={{fontSize:'12px',margin:'0px',marginBottom:'5px'}}>
                                                {lastresult}
                                            </div>
                                            <div className="row" style={{margin:'0px'}}>{lastpickname}</div>
                                        </div>
                                </div>
                                    
                                </div>
                                <div className="row subheadline-text left-align" style={{margin:'0px',padding:'0px'}}>
                                    {lineuphtml}
                                </div>
                            </div>
                        </div>

            allraces.push(resultcolhtml);
        }


        

        setRacePicksHTML(allraces);
    }


    function grabCurrentCollectionLeaderboards(collectionid) {
        var addData = new Object();
        addData.collectionID = encodeURIComponent(collectionid);

        axiosInstance.post('leaderboard/collection_list/',addData).then(result => {
            if(Object.keys(result.data).length > 0) {
                leaderboardList = result.data; 
                showCustomLeaderboards();
            } 
        }).catch(error => {
            console.log(error);
        });
    }

    function showCustomLeaderboards() {
        for(var j = 0; j < leaderboardList.length;j++) {
            grabProperLeaderboard(j);
        }
    }

    function grabProperLeaderboard(leaderboardnum) {
        var whitelistid = 0;
        var whitelistexclude = 0;
        if(leaderboardList[leaderboardnum]['leaderboard_whitelisted'] > 0) {
            whitelistid = leaderboardList[leaderboardnum]['race_collection_leaderboard_id'];
        }
        if(leaderboardList[leaderboardnum]['leaderboard_whitelist_exclude'] > 0) {
            whitelistexclude = leaderboardList[leaderboardnum]['leaderboard_whitelist_exclude'];
        }

        var customsort = 'event_'+exreventid;
        var ctimesort = 'all-time';
        var pagenum = 0;

        var addData = new Object();
        addData.racerID = encodeURIComponent(racerID);
        addData.walletID = encodeURIComponent(accountAddress);
        addData.userID = encodeURIComponent(current_user_id);
        addData.collectionID = encodeURIComponent(current_race_collection);
        addData.time = ctimesort;
        addData.page = pagenum;
        addData.sortBy = customsort;
        addData.rcount = total_page_results;
        addData.raceHost = encodeURIComponent(window.location.host);
        addData.whitelistID = whitelistid;
        addData.whitelistExcludeID = whitelistexclude;
        addData.userPositionCheck = current_user_id;

        var final_leaderboard_endpoint = 'leaderboard/racers_list/';
        if(leaderboardList[leaderboardnum]['leaderboard_type'] == 'predictor') {
            final_leaderboard_endpoint = 'leaderboard/prophets_list/';
        }

        if (finalLeaderboardNum < 0) {
            axiosInstance.post(final_leaderboard_endpoint,addData).then(result => {
                if(Object.keys(result.data).length > 0) {
                    finalLeaderboardNum = leaderboardnum;
                    finalUserPosition = result.data;
                }
                
                if (finalLeaderboardNum >= 0) {
                    grabCustomLeaderboard(finalLeaderboardNum,ctimesort,0);
                } else if (leaderboardnum == (leaderboardList.length-1)) {
                    finalLeaderboardNum = leaderboardList.length-1;
                    grabCustomLeaderboard(finalLeaderboardNum,ctimesort,0);
                }
            }).catch(error => {
                console.log(error);
            });
        }
        
    }

    function grabCustomLeaderboard(leaderboardnum,timeSort,pagenum) {
        var whitelistid = 0;
        var whitelistexclude = 0;
        if(leaderboardList[leaderboardnum]['leaderboard_whitelisted'] > 0) {
            whitelistid = leaderboardList[leaderboardnum]['race_collection_leaderboard_id'];
        }
        if(leaderboardList[leaderboardnum]['leaderboard_whitelist_exclude'] > 0) {
            whitelistexclude = leaderboardList[leaderboardnum]['leaderboard_whitelist_exclude'];
        }

        var customsort = 'event_'+exreventid;

        var addData = new Object();
        addData.racerID = encodeURIComponent(racerID);
        addData.walletID = encodeURIComponent(accountAddress);
        addData.userID = encodeURIComponent(current_user_id);
        addData.collectionID = encodeURIComponent(current_race_collection);
        addData.time = timeSort;
        addData.page = pagenum;
        addData.sortBy = customsort;
        addData.rcount = total_page_results;
        addData.raceHost = encodeURIComponent(window.location.host);
        addData.whitelistID = whitelistid;
        addData.whitelistExcludeID = whitelistexclude;

        var final_leaderboard_endpoint = 'leaderboard/racers_list/';
        if(leaderboardList[leaderboardnum]['leaderboard_type'] == 'predictor') {
            final_leaderboard_endpoint = 'leaderboard/prophets_list/';
        }

        axiosInstance.post(final_leaderboard_endpoint,addData).then(result => {
            var leaderboard_details = result.data; 
            leaderboardList[leaderboardnum]['leaderboard_data'] = leaderboard_details;
            var totalboardsfilled = 0;
            loadCustomLeaderboards(0);
        }).catch(error => {
            console.log(error);
        });
    }


    function loadCustomLeaderboards(pagenum) {
        var custom_section_html = [];

        for(var m = 0; m < leaderboardList.length;m++) {
            if ('leaderboard_data' in leaderboardList[m]) {
                var pilotcnt = 0;
                var boarddata = leaderboardList[m]['leaderboard_data'];
                var boardtype = leaderboardList[m]['leaderboard_type'];
                var rpmtracked = leaderboardList[m]['rpm_tracked'];
                var xptracked = leaderboardList[m]['xp_tracked'];
                var rpmmultiplier = leaderboardList[m]['rpm_multiplier'];
                var xpmulitplier = leaderboardList[m]['xp_multiplier'];
                var maxraces = leaderboardList[m]['total_races_max'];
                var countedraces = leaderboardList[m]['total_races_count'];
                
                if(finalUserPosition.length > 0) {
                    boarddata.unshift(finalUserPosition[0]);
                }
                var ranking_section_html = [];
                var standingfound = 0;
                var standinghtml = <></>;
                for(var z = 0; z < boarddata.length;z++) {
                    var board_user_id = boarddata[z].user_id;
                    var board_racer_id = boarddata[z].racer_id;
                    var board_racer_name = boarddata[z].racer_name;
                    var total_rpm = boarddata[z].rpm_earned;
                    var total_xp = boarddata[z].xp_earned;
                    var racer_photo = boarddata[z].racer_photo;

                    /* Position Summary */
                    var userfinalstanding = 0;
                    if ('current_standing' in boarddata[z]) {
                        userfinalstanding = boarddata[z].current_standing;
                        standingfound = 1;
                    }

                    /* Racer Specific */
                    var racer_coins = 0;
                    var racer_xp = 0
                    var leaderboard_winner_type = '';
                    var total_races = 0;
                    var total_wins = 0;
                    var win_pct = 0;
                    if(boardtype == 'racer') {
                        racer_coins = boarddata[z].racer_coins;
                        racer_xp = boarddata[z].racer_xp;
                        racer_photo = boarddata[z].racer_photo;
                        leaderboard_winner_type = boarddata[z].leaderboard_winner_type;
                        total_races = boarddata[z].total_races;
                        total_wins = boarddata[z].total_wins;
                        win_pct = Math.round((total_wins / total_races)*100);
                    }

                    /* Predictor Specific */
                    var total_predicted = 0;
                    var total_correct = 0;
                    var correct_pct = 0;
                    if(boardtype == 'predictor') {
                        total_predicted = boarddata[z].total_predictions;
                        total_correct = boarddata[z].total_predictions_correct;
                        correct_pct = Math.round((total_correct / total_predicted)*100);
                    }
                    
                    var rowcolor = 'white-text';
                    var rowbgcolor = '';
                    if(board_racer_id == racerID) {
                        rowcolor = 'exr-light-green-text';
                        //rowbgcolor = 'exr-stats-light-grey';
                    } 

                    if((racer_photo == '')||(racer_photo == null)) {
                        racer_photo = bot_pilots[Math.floor(Math.random(3))];
                    }

                    var pilot_image = <div className="exr-stats-light-grey" style={{width:'50px',height:'50px',borderRadius:'5px',marginBottom:'7px'}}></div>;
                    if(racer_photo !== null) {
                        pilot_image = <img src={racer_photo} width="50px" style={{borderRadius:"5px",lineHeight:'1'}} />;
                    }

                    var statshtml = <><div className="col s2 center-align" title="RPM Awarded" style={{marginTop:"12px"}}>
                                            {racer_coins.toLocaleString("en-US")}
                                        </div>
                                        <div className="col s2 center-align" title="XP Earned" style={{marginTop:"12px"}}>
                                            {racer_xp.toLocaleString("en-US")}
                                        </div>
                                        <div className="col s2 center-align" style={{marginTop:"12px"}}>
                                            {total_wins}
                                        </div></>;
                    if(boardtype == 'predictor') {
                        statshtml = <><div className="col s2 center-align" title="XP Earned" style={{marginTop:"12px"}}>
                                        {total_xp.toLocaleString("en-US")}
                                    </div>
                                    <div className="col s2 center-align" style={{marginTop:"12px"}}>
                                        {total_correct}
                                    </div>
                                    <div className="col s2 center-align" style={{marginTop:"12px"}}>
                                        {correct_pct+'%'}
                                    </div></>
                    }

                    var boardsubtitlepx2 = "16px";
                    if(leaderboardList.length == 3) {
                        boardsubtitlepx2 = "12px";
                    }

                    var rowkey = z+1+(pagenum*total_page_results)+'board'+m;
                    var rownum = z+1+(pagenum*total_page_results)-standingfound;
                    var rowtype = 'race-board-row';
                    var rowspacing = '0px';
                    var rowtitlerow = <></>;
                    var rowspacer = <></>;
                    if(userfinalstanding > 0) {
                        rowkey = userfinalstanding+'boardpos'+m;
                        rownum = userfinalstanding;
                        rowbgcolor = 'exr-stats-light-grey';
                        rowtype = 'user-current-position';
                        rowspacing = '10px';
                        rowcolor = 'white-text';
                        boardsubtitlepx2 = '14px';
                        rowtitlerow = <div className="col s12 headline-text white-text" style={{paddingLeft:'20px',marginTop:'15px',marginBottom:'10px',overflow:'hidden',fontSize:'14px'}}>
                                            YOUR RANKING
                                        </div>;
                        rowspacer = <div className="col s12 section-title-underline" style={{marginTop:'-5px',marginBottom:'0px',height:'0px'}}></div>;
                    }
                    var tmp_html = <><div key={rowkey} className={"row "+rowtype} id={'leader_row_'+board_racer_id} style={{cursor:'auto',marginBottom:'0px',paddingTop:'7px',paddingBottom:'0px'}}>
                                    <div className={"row "+rowcolor+" "+rowbgcolor} style={{marginTop:'0px',marginBottom:'0px',paddingBottom:rowspacing,borderRadius:'10px',fontSize:boardsubtitlepx2}}>
                                        {rowtitlerow}
                                        <div className="col s6" style={{overflow:'hidden'}}>
                                            <div className="left" style={{width:'200%'}}>
                                                <div className="left headline-text center-align" style={{fontSize:boardsubtitlepx2,marginRight:"10px",letterSpacing:"-1px",width:"50px",marginTop:"15px",fontWeight:'900'}}>
                                                    {rownum}
                                                </div>
                                                <div className="left" style={{marginRight:"10px",width:"50px"}}>
                                                    {pilot_image}
                                                </div>
                                                <div className="left" style={{marginTop:"12px"}}>
                                                    {board_racer_name}
                                                </div>
                                            </div>
                                        </div>
                                        {statshtml}
                                    </div>
                                    
                                </div></>;
                    if(userfinalstanding == 0) {
                        ranking_section_html.push(tmp_html);
                    } else {
                        standinghtml = tmp_html;
                    }
                    
                }

                

                var final_section_html_array = [];
                if(pagenum > 0) {
                    final_section_html_array = leaderboardList[m]['leaderboard_html'].concat(ranking_section_html);
                } else {
                    final_section_html_array = ranking_section_html;
                }
                leaderboardList[m]['leaderboard_html'] = final_section_html_array;

                var boardcols = "col s12";
                var boardtitlepx = "16px";
                var boardsubtitlepx = "14px";

                var boardmax = <>TOP {countedraces} RACES</>;
                var boardfilters = <><div className="col s2 headline-text white-green-link-active racer-row-sort-link center-align" title="Sort by Most RPM" 
                                            id="racer-lb-sort-rpm" 
                                            style={{fontSize:boardsubtitlepx}}>
                                            RPM
                                        </div>
                                        <div className="col s2 headline-text white-green-link racer-row-sort-link center-align" title="Sort by Most XP" 
                                            id="racer-lb-sort-xp" 
                                            style={{fontSize:boardsubtitlepx}}>
                                            XP
                                        </div>
                                        <div className="col s2 headline-text white-green-link racer-row-sort-link center-align" title="Sort by Most Wins" 
                                            id="racer-lb-sort-wins" 
                                            style={{fontSize:boardsubtitlepx}}>
                                            WINS
                                        </div></>;
                if(boardtype == 'predictor') {
                    boardmax = <>TOP 10 WIN</>;
                    boardfilters = <><div className="col s2 headline-text white-green-link-active prophet-row-sort-link center-align" title="Sort by Most XP" 
                                            id="prophet-lb-sort-xp" 
                                            style={{fontSize:boardsubtitlepx}}>
                                            XP
                                        </div>
                                        <div className="col s2 headline-text white-green-link prophet-row-sort-link center-align" title="Sort by Most Correct Picks" 
                                            id="prophet-lb-sort-wins" 
                                            style={{fontSize:boardsubtitlepx}}>
                                            WINS
                                        </div>
                                        <div className="col s2 headline-text white-green-link prophet-row-sort-link center-align" title="Sort by Highest Percent Correct" 
                                            id="prophet-lb-sort-win_pct" 
                                            style={{fontSize:boardsubtitlepx}}>
                                            PCT
                                        </div></>;
                }

                var final_board_html = <div className={boardcols} style={{padding:'5px'}}>
                            <div className="row exr-new-dark-grey" style={{margin:'0px',marginBottom:'10px',padding:'20px',borderRadius:'10px',minHeight:'70vh'}}>
                                {standinghtml}
                                <div className="row" style={{margin:'0px',marginBottom:'10px'}}>
                                    <div className="col s8 m8 headline-text white-text left-align" style={{marginTop:'0px',fontSize:boardtitlepx}}>
                                        {leaderboardList[m]['leaderboard_name'].toUpperCase()}
                                    </div>
                                    <div className="col s4 m4 white-text right-align  exr-yellow-text" style={{fontSize:'14px'}} title={"Top "+countedraces+" pick results count towards the leaderboard"}>
                                        {boardmax}
                                    </div>
                                </div>
                                
                                <div className="section-title-underline" style={{marginTop:'-5px',marginBottom:'0px',height:'0px'}}></div>
                                <div className="row" style={{marginBottom:'5px',marginTop:'5px',fontSize:'14px'}}>
                                    <div className="col s1 headline-text white-text">
                                        &nbsp;&nbsp;&nbsp;&nbsp;#
                                    </div>
                                    <div className="col s5 headline-text white-text" style={{fontSize:boardsubtitlepx}}>
                                        {boardtype.toUpperCase()}
                                    </div>
                                    {boardfilters}
                                </div>
                                <div className="section-title-underline" style={{marginTop:'-5px',marginBottom:'0px',height:'0px'}}></div>
                                {final_section_html_array}
                            </div>
                        </div>;

                custom_section_html.push(final_board_html);
            }
        }
        setCustomLeaderboardHTML(custom_section_html);
    }

    useEffect(() => {
        LogRocket.init('d47cge/trackmeets');

        if((userID > 0)&&(userID !== undefined)) {
            current_user_id = userID;
        }
        setTimeout(function(){
            if((userID > 0)&&(userID !== undefined)) {
                current_user_id = userID;
                showEmailLoggedIn();
                
            }
        },500);
        startFixedModals();
    }, []);

    document.addEventListener('DOMContentLoaded', function() {

        if((userID > 0)&&(userID !== undefined)) {
            current_user_id = userID;
        }
        setTimeout(function(){
            if((userID > 0)&&(userID !== undefined)) {
                current_user_id = userID;
                showEmailLoggedIn();
            }
        },500);
    });

    function showLoginBox(e) {
        e.preventDefault();
        window.location.href="/#/signin&p=login";
    }

    function showRegisterBox() {
        window.location.href="/#/register";
    }

    function goToLearnSite() {
        window.location.href="/#/gameplay";
    }

    function goToMintSite() {
        window.location.href="https://mint.exiledracers.com"
    }

    function goToCollectionViewer() {
        window.location.href="https://view.exiledracers.com"
    }

    function showRacewayPage() {
        window.location.href="/#/raceway";
    }

    function showEmailSendSent() {
        setTimeout(function(){
            $("#email-send-button").hide();
            $("#email-sent-loading").hide();
            $("#email-sent-button").show();
            $("#email-code-form").slideDown();
        },3000);
    }

    function showEmailSendReset() {
        $("#email-send-button").show();
        $("#email-sent-loading").hide();
        $("#email-sent-button").hide();
    }

    function showEmailLoggedIn() {
        setTimeout(function(){
            $("#email-send-button").hide();
            $("#email-sent-loading").hide();

            // Update Race Participants
            grabRewardsSectionData();
            grabRaceParticipantsLoop();
            grabCurrentCollectionLeaderboards(current_race_collection);
            moveToTicketingPage();
        },2000);
    }

    function showEmailCodeApproved() {
        setTimeout(function(){
            $("#code-send-button").hide();
            $("#code-confirmed-loading").hide();
            $("#code-confirmed-button").show();

            // Update Race Participants
            grabRaceParticipantsLoop();
            grabCurrentCollectionLeaderboards(current_race_collection);
            moveToTicketingPage();
        },3000);
    }

    function showEmailCodeReset() {
        $("#code-send-button").show();
        $("#code-confirmed-loading").hide();
        $("#code-confirmed-button").hide();
    }

    function toggleRacerRow(e) {
        e.preventDefault();

        var racer_tmp_id = 0;
        let race_elem = e.target;
        while(racer_tmp_id == 0) {
            if(race_elem.dataset.racerrow) {
                racer_tmp_id = race_elem.dataset.racerrow;
            } else {
                race_elem = race_elem.parentElement;
            }
        }
        if($("#racer-stack-show-"+racer_tmp_id).is(':visible')) {
            $("#racer-stack-show-"+racer_tmp_id).slideUp();
            $("#racer-stack-show-icon-"+racer_tmp_id).html('expand_more');
        } else {
            $("#racer-stack-show-"+racer_tmp_id).slideDown();
            $("#racer-stack-show-icon-"+racer_tmp_id).html('expand_less');
        }
    }

    function toggleTicketingWidget() {
        if($("#ticketing-widget").is(":visible")) {
            $("#ticketing-widget").slideUp();
        } else {
            $("#ticketing-widget").slideDown();
        }
    }

    function showViewPredictions() {
        moveToNextStepPage(6);
    }

    function showCurrentLeaderboard() {
        moveToNextStepPage(7);
    }

    function showLiveFeed() {
        moveToNextStepPage(8);
    }

    function showEventCollectible() {
        moveToNextStepPage(5);
    }

    function viewEventCollectible() {
        // var video_url = 'https://media.exiledracers.com/assets/passes/exr_track_meet_collectible_nft.mp4';
        // $("#rewards-video").attr("src",video_url+"#t=0.9");

        var infobox = document.getElementById('rewards_content_show');
        var info_instance = window.M.Modal.getInstance(infobox);
        info_instance.destroy();
        
        setTimeout(function(){
            var infobox = document.getElementById('rewards_content_show');
            var info_instance = window.M.Modal.init(infobox,{'opacity':0.75,onOpenStart: function(){
                if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                    $(".modal").css({'width':'95%'});
                } else {
                    $(".modal").css({'width':'50%'});
                }
            }, onCloseEnd: function(){
                var current_video = document.getElementById('rewards-video');
                current_video.pause();
            }});
            
            var info_instance = window.M.Modal.getInstance(infobox);
            info_instance.open();
            updateVideoSize();
        },1000);

        setTimeout(function(){
            var current_video = document.getElementById('rewards-video');
            current_video.play();
        },2000);
        
    }

    function updateVideoSize() {
        var current_video = document.getElementById('rewards-video');
        var video_orientation = 'H';
        if(current_video.videoHeight >= current_video.videoWidth) {
            video_orientation = 'V';
        }

        if(video_orientation == 'V') {
            $("#rewards_content_show").addClass("page-modal-media-vertical");
            $("#rewards-video").css({height:'79.5vh',width:'auto'});
        } else {
            $("#rewards_content_show").removeClass("page-modal-media-vertical");
            $("#rewards-video").css({height:'auto',width:'100%'});
        }
    }

    function showWalletTransferModal() {
        var infobox = document.getElementById('rewards_transfer');
        var info_instance = window.M.Modal.getInstance(infobox);
        info_instance.open();
    }

    function startFixedModals() {
        var infobox = document.getElementById('rewards_transfer');
        var info_instance = window.M.Modal.init(infobox,{'opacity':0.75,onOpenStart: function(){
            if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
                $(".modal").css({'width':'95%'});
            } else {
                $(".modal").css({'width':'50%'});
            }
        }});
    }

    function moveToNextStepPage(nextstep) {
        $("#event-register-page-"+nextstep).slideDown();
        $('html, body').animate({
            scrollTop: $("#event-register-page-"+nextstep).offset().top
         }, 1000);
    }

    function moveToTicketingPage() {
        $("#event-ticketing-page").slideDown();
        $("#event-register-page-6").slideDown();
        $("#event-register-page-7").slideDown();
        $("#event-register-page-8").slideDown();
        $("#event-register-page-9").slideDown();
        $('html, body').animate({
            scrollTop: $("#event-ticketing-page").offset().top
         }, 1000);
    }


    function grabRewardsSectionData() {
        var addData = new Object();
        addData.userID = encodeURIComponent(userID);
        addData.collectionID = encodeURIComponent(7);
        addData.rewardType = encodeURIComponent('session_collectible');

        axiosInstance.post('member/rewards_list/',addData).then(result => {
            if(Object.keys(result.data).length > 0) {
                var rewards_info = result.data;
                var this_reward_id = rewards_info[0]['rewards_id'];
                var this_collection_id = rewards_info[0]['race_group_collection_id'];
                var reward_custodial = rewards_info[0]['exr_custodial_flag'];

                var reward_wallet_address = rewards_info[0]['wallet_address'];
                setRewardWalletAddress(reward_wallet_address);

                if(reward_custodial == 0) {
                    setRewardWalletName('User Wallet');
                    
                } else {
                    $("#manageRewardButton").show();
                    setRewardWalletName('EXR Account');
                    $("#rewardtransferstart").show();
                    var tmp_rewardsbox_vars = <>
                                <input type="hidden" id="reward-token-name" value="exr_collectible" />
                                <input type="hidden" id="reward-token-id" value={this_collection_id} />
                                <input type="hidden" id="reward-token-amount" value="0" />
                                <input type="hidden" id="reward-id" value={this_reward_id} />
                            </>;
                    setRewardTransferHiddenVars(tmp_rewardsbox_vars);
                }
                
                var tmp_rewardsbox_media = <video id="rewards-transfer-video" src="https://media.exiledracers.com/assets/passes/exr_track_meet_collectible_nft.mp4#t=0.9" 
                                                controls="true" style={{padding:'0px',margin:'0px',borderRadius:'10px',width:'100%'}} />;
                setRewardTransferBoxMedia(tmp_rewardsbox_media);

                $("#event-register-page-5").show();
                
            } else {
                $("#event-register-page-5").hide();
                $("#rewardtransferstart").hide();
                setRewardWalletName('EXR Unlock');
                setRewardWalletAddress('Not Eligible For Collectible');
                setTimeout(function(){
                    $("#event-register-page-5").hide();
                },2000);
            }
        }).catch(error => {
            console.log(error);
        });
    }

    function showWalletMoonscan() {
        var final_link = 'https://moonscan.io/address/'+rewardWalletAddress+'#tokentxnsErc1155';
        window.open(final_link,'_blank');
    }

    function transferStart() {
        $("#rewardtransfernewwallet").show();
        $("#rewardtransferconfirm").show();
        $("#rewardtransfercancel").show();
        $("#rewardtransferdivider").show();
        $("#rewardtransferstart").hide();
    }

    function transferEmailCodeSent() {
        var recipientAddress = $("#personalWalletAddress").val();

        var addData = new Object();
        addData.userID = encodeURIComponent(userID);
        addData.recipientAddress = encodeURIComponent(recipientAddress);

        if((recipientAddress.length < 30)||(recipientAddress.indexOf('0x') < 0)) {
            alert('Add Valid Recipient Address');
        } else {
            $("#rewardtransferconfirm").hide();
            $("#rewardtransferstart").hide();
            $("#rewardtransferloading").show();
            $("#personalWalletAddress").prop("disabled", true);
            axiosInstance.post('member/rewards_wallet_check/',addData).then(result => {
                if(Object.keys(result.data).length > 0) {
                    setTimeout(function() {
                        $("#rewardtransfersubmit").show();
                        $("#rewardtransfercode").show();
                        $("#rewardtransferloading").hide();
                    },3000);
                } 
            }).catch(error => {
                console.log(error);
            });
        }
    }

    function completeTransfer() {

        var tokenName = $("#reward-token-name").val();
        var tokenID = $("#reward-token-id").val();
        var confirmCode = $("#transferEmailCode").val();
        var amountTransfer = $("#reward-token-amount").val();
        var recipientAddress = $("#personalWalletAddress").val();
        var rewardsID = $("#reward-id").val();

        var addData = new Object();
        addData.userID = encodeURIComponent(userID);
        addData.tokenName = encodeURIComponent(tokenName);
        addData.tokenID = encodeURIComponent(tokenID);
        addData.confirmCode = encodeURIComponent(confirmCode);
        addData.amountTransfer = encodeURIComponent(amountTransfer);
        addData.recipientAddress = encodeURIComponent(recipientAddress);
        addData.rewardsID = encodeURIComponent(rewardsID);
        if(confirmCode.length < 5) {
            alert('Add Valid Email Code');
        } else if((recipientAddress.length < 30)||(recipientAddress.indexOf('0x') < 0)) {
            alert('Add Valid Recipient Address');
        } else {
            if(window.confirm('Warning: Transfers are permanent! Double check to make sure this is the wallet address you want to send to. Are you sure you want to transfer to wallet: '+recipientAddress+'? ')) {
                $("#rewardtransfersubmit").hide();
                $("#rewardtransferconfirm").hide();
                $("#rewardtransferstart").hide();
                $("#rewardtransfercancel").hide();
                $("#rewardtransferloading").show();
    
                axiosInstance.post('member/rewards_wallet_transfer/',addData).then(result => {
                    if(Object.keys(result.data).length > 0) {
                        
                        setTimeout(function() {
                            setRewardWalletName('User Wallet');
                            setRewardWalletAddress(recipientAddress);
                            $("#rewardtransfercomplete").show();
                            $("#rewardtransferloading").hide();
                            $("#rewardtransfercode").hide();
                        },3000);
                    } 
                }).catch(error => {
                    console.log(error);
                });      
            }  
        }
    }

    function cancelTransfer() {
        $("#rewardtransfernewwallet").hide();
        $("#rewardtransfercode").hide();
        $("#rewardtransfersubmit").hide();
        $("#rewardtransferconfirm").hide();
        $("#rewardtransfercancel").hide();
        $("#rewardtransferdivider").hide();
        $("#rewardtransferstart").show();
        $("#personalWalletAddress").prop("disabled", false);
        $("#personalWalletAddress").val('');
        $("#transferEmailCode").val('');
    }


    function checkRewardsWalletBalance() {
        var addData = new Object();
        addData.userID = encodeURIComponent(userID);
        // addData.tokenName = encodeURIComponent('usdc');
        // addData.tokenID = 0;

        addData.tokenName = encodeURIComponent('nft');
        addData.tokenID = 7;

        axiosInstance.post('member/rewards_wallet_balance/',addData).then(result => {
            if(Object.keys(result.data).length > 0) {
                let rewards_wallet_info = result.data; 
            } 
        }).catch(error => {
            console.log(error);
        });
    }

    window.addEventListener('resize', function() {
        window.resetCenterHeight();
    });

    if(setPage === false) {
        pageSet(true);
        if((userID > 0)&&(userID !== undefined)) {
            current_user_id = userID;
            showEmailLoggedIn();
        }
    }

    window.addEventListener("hashchange",
    function(){ 
        window.location.reload(); 
    }, false);

    return(<div style={{position:'relative',width:'auto',height:'auto'}}>
        <div className="row" id="event-register-page-1" style={{position:'relative',minWidth:'100vw',minHeight:'95vh'}}>
            <div id="splash-image-container" style={{width:'100vw',minHeight:'100vh',height:'100%',overflow:'hidden',position:'absolute',top:'0px',left:'0px', zIndex:'-20',background:'url('+bg_image+')',backgroundSize:'cover',backgroundPosition:'center'}}>
            </div>
            <div className="exr-trans-black-bg center-align white-text" 
                    style={{width:'100vw',minHeight:'100vh',height:'100%',
                            position:'absolute',zIndex:'-10',top:'0px',left:'0px',
                            padding:'20px',fontSize:'20px',
                            background:'rgb(240,91,39,.65)'}}>
            </div>
            <div className="col s12 transparent" style={{position:'relative',zIndex:'10'}}>
                <div id="splash-main-buttons">
                    <div className="row firstsection" style={{marginBottom:'0px',padding:'0px 20px'}}>
                        <div className="col s12 m10 offset-m1 black-text">
                            <div className="headline-text event-register-large-headline">
                                LOGIN TO EXR TRACK MEET
                            </div>
                        </div>
                        <div className="col s12 m10 offset-m1 white-text">
                            <div className="subheadline-text white-text event-register-subheadline">
                                GET YOUR COLLECTIBLE <span className="black-text">+</span>&nbsp;
                                VIEW RACE RESULTS <span className="black-text">+</span>&nbsp;
                                CHECK LEADERBOARDS
                            </div>
                        </div>
                    </div>
                    <div className="row black-text" id="email-address-form" style={{marginTop:'80px',padding:'0px 20px'}}>
                        <div className="col s12 m10 offset-m1">
                            <span className="left headline-text event-register-formheader" 
                                style={{width:'100%'}} title="Login To Exiled Racers">
                                ENTER EMAIL ADDRESS
                            </span>
                        </div>
                        <div className="col s12 m7 offset-m1 l5 offset-l1" style={{marginBottom:'20px'}}>
                            <span className="left" style={{width:'100%',fontSize:'20px',lineHeight:'1em !important',height:'calc(1em + 10px)'}} title="Enter Email Address to Login">
                                <input id="racerEmailAddress" className="black-bubble-input-dark" 
                                    style={{width:'100%',fontSize:'20px',borderColor:'black'}} />
                            </span>
                        </div>
                        <div className="col s12 m4 l6">
                            <span id="email-send-button" className="round-border-button event-register-formbutton black white-text" 
                                style={{width:'auto',borderRadius:'5px',border:'0px'}} 
                                title="Login To Exiled Racers" onClick={()=>sendEventEmailCode()}>
                                <span className="left" style={{margin:"6px 5px 0px 5px"}}>SUBMIT</span>
                            </span>
                            <span id="email-sent-loading" className="preloader-wrapper small active event-register-formbutton" 
                                style={{display:'none',height:'30px',width:'30px',marginTop:'3px'}}>
                                <div className="spinner-layer spinner-yellow-only">
                                    <div className="circle-clipper left">
                                        <div className="circle"></div>
                                    </div>
                                    <div className="gap-patch">
                                        <div className="circle"></div>
                                    </div>
                                    <div className="circle-clipper right">
                                        <div className="circle"></div>
                                    </div>
                                </div>
                            </span>
                            <span id="email-sent-button" className="round-border-button-green event-register-formbutton black-text" 
                                style={{display:'none',width:'auto',borderRadius:'5px',border:'2px solid black'}} title="Email Code Sent">
                                <span className="left" style={{margin:"5px"}}>EMAIL CODE SENT</span>
                            </span>
                        </div>
                    </div>
                    <div className="row black-text" id="email-code-form" style={{display:'none',marginTop:'60px',padding:'0px 20px'}}>
                        <div className="col s12 m10 offset-m1">
                            <span className="left headline-text event-register-formheader" title="Login To Exiled Racers">
                                ENTER EMAIL CODE
                            </span>
                        </div>
                        <div className="col s12 m7 offset-m1 l5 offset-l1" style={{marginBottom:'20px'}}>
                            <span className="left" style={{width:'100%',fontSize:'20px',lineHeight:'1em !important',height:'calc(1em + 10px)'}} 
                                title="Enter Email Confirmation to Complete Login">
                                <input id="racerEmailCode" className="black-bubble-input-dark" style={{width:'100%',fontSize:'20px'}} />
                            </span>
                        </div>
                        <div className="col s12 m4 l6">
                            <span id="code-send-button" className="round-border-button event-register-formbutton black white-text" 
                                style={{width:'auto',borderRadius:'5px',border:'0px'}} 
                                title="Login To Exiled Racers" onClick={()=>checkEventEmailCode()}>
                                <span className="left" style={{margin:"6px 5px 0px 5px"}}>SUBMIT</span>
                            </span>
                            <span id="code-confirmed-loading" className="preloader-wrapper small active event-register-formbutton" 
                                style={{display:'none',height:'30px',width:'30px',marginTop:'3px'}}>
                                <div className="spinner-layer spinner-yellow-only">
                                    <div className="circle-clipper left">
                                        <div className="circle"></div>
                                    </div>
                                    <div className="gap-patch">
                                        <div className="circle"></div>
                                    </div>
                                    <div className="circle-clipper right">
                                        <div className="circle"></div>
                                    </div>
                                </div>
                            </span>
                            <span id="code-confirmed-button" className="round-border-button-green event-register-formbutton black-text" 
                                style={{display:'none',width:'auto',borderRadius:'5px',border:'2px solid black'}} title="Email Code Sent">
                                <span className="left" style={{margin:"5px"}}>CODE CONFIRMED</span>
                            </span>
                        </div>
                    </div>
                    <div className="row" style={{marginTop:'150px',marginBottom:'70px',padding:'0px 20px'}}>
                        <div className="col s12 m5 l4 offset-m1 offset-l1 main-sponsor-icons" style={{padding:'0px'}}>
                            <a href="/" className="white-text">
                                <img id="exr-logo-button" style={{cursor:'pointer'}} title="Exiled Racers" width="250px" src={logo_image} />
                            </a>
                        </div>
                        <div className="col s12 m6 l7 main-sponsor-icons" style={{padding:'0px'}}>
                            <a href="/" className="white-text" style={{marginRight:'20px'}}>
                                <img id="polkadot-logo-button" style={{cursor:'pointer'}} title="Polkadot" width="57px" src={polka_logo} />
                            </a>
                            <a href="/" className="white-text" style={{marginRight:'20px'}}>
                                <img id="moonbeam-logo-button" style={{cursor:'pointer'}} title="Moonbeam" width="60px" src={moonbeam_logo} />
                            </a>
                            <a href="/" className="white-text" style={{marginRight:'0px'}}>
                                <img id="zeitgeist-logo-button" style={{cursor:'pointer'}} title="Zeitgeist" width="62px" src={ztg_logo} />
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="row" id="event-ticketing-page" style={{display:'none',position:'relative',width:'100vw',minHeight:'100vh',marginBottom:'0px'}}>
            <div id="splash-image-container" style={{width:'100vw',minHeight:'100vh',height:'100%',overflow:'hidden',position:'absolute',top:'0px',left:'0px', zIndex:'-20',background:'url('+bg_image+')',backgroundSize:'cover',backgroundPosition:'center'}}>
            </div>
            <div className="exr-trans-black-bg center-align white-text" style={{width:'100vw',minHeight:'100vh',height:'100%',position:'absolute',zIndex:'-10',top:'0px',left:'0px',padding:'20px',fontSize:'20px'}}>
            </div>
            <div className="col s12 transparent white-text" style={{position:'relative',zIndex:'10'}}>
                <div className="row firstsection" style={{marginBottom:'10px'}}>
                    <div className="col s12 m10 offset-m1 white-text">
                        <div className="row headline-text white-text event-register-large-headline" style={{lineHeight:'1.1',padding:'0px 20px'}}>
                            CONGRATS, YOU'RE IN.
                        </div>
                        <div className="row headline-text exr-orange-text event-register-large-headline" style={{lineHeight:'1.1',padding:'0px 20px'}}>
                            CHECK OUT YOUR UNLOCKS   
                        </div>
                        <div className="row" style={{marginTop:'80px',marginBottom:'0px',lineHeight:'1.1',padding:'0px 20px'}}>
                            <div className="row" style={{margin:'50px 0px',lineHeight:'1.1',color:'silver'}}>
                                <div className="col s12 l6" style={{display:'none',margin:'0px',padding:'10px'}}>
                                    <div className="row center white black-text" style={{margin:'0px',padding:'15px 10px',marginBottom:'10px',cursor:'pointer',borderRadius:'5px'}}
                                        onClick={()=>toggleTicketingWidget()}>
                                        <div className="row headline-text" style={{margin:'0px',fontSize:'24px',padding:'0px',marginBottom:'10px',marginTop:'15px'}}>
                                            GET YOUR EVENT TICKET
                                        </div>
                                        <div className="row subheadline-text" style={{margin:'0px',fontSize:'14px',padding:'0px',marginBottom:'20px'}}>
                                            CAPACITY LIMITED. 1ST COME 1ST SERVE. 21+ ONLY.
                                        </div>
                                        <div className="row subheadline-text" style={{margin:'0px',fontSize:'14px',padding:'0px',marginBottom:'20px'}}>
                                            NOTE: YOU WILL BE REDIRECTED TO POSH.VIP TO CLAIM YOUR TICKET
                                        </div>
                                        <div id="ticketing-widget" className="row subheadline-text center" style={{margin:'0px',fontSize:'18px',padding:'0px'}}>
                                            <iframe
                                                src="https://embed.posh.vip/ticket-iframe/64f4beb601b1d12fb026e395/"
                                                height='235px'
                                                width='100%'
                                                style={{border: 'none'}}
                                            ></iframe>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div className="col s12 l6" style={{margin:'0px',padding:'10px'}}>
                                    <div className="row center white black-text" style={{margin:'0px',padding:'15px 10px',marginBottom:'10px',cursor:'pointer',borderRadius:'5px'}} 
                                        onClick={()=>showLiveFeed()}>
                                        <div className="row headline-text" style={{margin:'0px',fontSize:'18px',padding:'0px',marginBottom:'5px'}}>
                                            EVENT STREAM REPLAY
                                        </div>
                                        <div className="row subheadline-text" style={{margin:'0px',fontSize:'18px',padding:'0px'}}>
                                            CLICK TO WATCH
                                        </div>
                                    </div>
                                </div>
                                <div className="col s12 l6" style={{margin:'0px',padding:'10px'}}>
                                    <div className="row center white black-text" style={{margin:'0px',padding:'15px 10px',marginBottom:'10px',cursor:'pointer',borderRadius:'5px'}}
                                        onClick={()=>showViewPredictions()}>
                                        <div className="row headline-text" style={{margin:'0px',fontSize:'18px',padding:'0px',marginBottom:'5px'}}>
                                            PREDICTIONS
                                        </div>
                                        <div className="row subheadline-text" style={{margin:'0px',fontSize:'18px',padding:'0px'}}>
                                            VIEW YOUR PICKS 
                                        </div>
                                    </div>
                                </div>
                                <div className="col s12 l6" style={{margin:'0px',padding:'10px'}}>
                                    <div className="row center white black-text" style={{margin:'0px',padding:'15px 10px',marginBottom:'10px',cursor:'pointer',borderRadius:'5px'}} 
                                        onClick={()=>showCurrentLeaderboard()}>
                                        <div className="row headline-text" style={{margin:'0px',fontSize:'18px',padding:'0px',marginBottom:'5px'}}>
                                            LEADERBOARDS
                                        </div>
                                        <div className="row subheadline-text" style={{margin:'0px',fontSize:'18px',padding:'0px'}}>
                                            CHECK YOUR RANKING
                                        </div>
                                    </div>
                                </div>
                                <div className="col s12 l6" style={{margin:'0px',padding:'10px'}}>
                                    <div className="row center white black-text" style={{margin:'0px',padding:'15px 10px',marginBottom:'10px',borderRadius:'5px',cursor:'pointer'}}
                                        onClick={()=>showEventCollectible()}>
                                        <div className="row headline-text" style={{margin:'0px',fontSize:'18px',padding:'0px',marginBottom:'5px'}}>
                                            EVENT COLLECTIBLE
                                        </div>
                                        <div className="row subheadline-text" style={{margin:'0px',fontSize:'18px',padding:'0px'}}>
                                            VIDEO UNLOCKED
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="row" id="event-register-page-5" style={{display:'none',position:'relative',width:'100vw',minHeight:'95vh'}}>
            <div id="splash-image-container" style={{width:'100vw',minHeight:'100vh',height:'100%',overflow:'hidden',position:'absolute',top:'0px',left:'0px', zIndex:'-20',background:'url('+bg_image_blurred+')',backgroundSize:'cover',backgroundPosition:'center'}}>
            </div>
            <div className="exr-trans-black-bg center-align white-text" style={{width:'100vw',minHeight:'100vh',height:'100%',position:'absolute',zIndex:'-10',top:'0px',left:'0px',padding:'20px',fontSize:'20px'}}>
            </div>
            <div className="col s12 transparent" style={{position:'relative',zIndex:'10'}}>
                <div id="splash-main-buttons">
                    <div className="row firstsection" style={{marginBottom:'10px'}}>
                        <div className="col s12 m10 offset-m1 white-text">
                            <div className="row" style={{marginTop:'30px',marginBottom:'50px',lineHeight:'1.1'}}>
                                <div className="col s12 l6 hide-on-med-and-down show-on-large-only" style={{color:'silver'}}>
                                    <div className="row subheadline-text center" style={{marginTop:'10px',marginBottom:'50px',position:'relative'}} 
                                        onClick={()=>viewEventCollectible()} title="View Event Collectible">
                                        <img src="https://media.exiledracers.com/assets/banners/exr_track_meet_pool.jpg" style={{height:'70vh',borderRadius:'10px',cursor:'pointer'}} />
                                        <span className="exr-trans-black-bg-subtle" style={{position:'absolute',top:'0%',left:'0%',width:'100%',height:'100%',cursor:'pointer'}}></span>
                                        <span class="material-icons material-symbols-rounded white-text" style={{position:'absolute',top:'40%',left:'40%',fontSize:'120px',cursor:'pointer'}}>play_arrow</span>
                                    </div>
                                </div>
                                
                                <div className="col s12 l6 white-text"style={{marginTop:'15vh',position:'relative',padding:'0px 50px'}}>
                                    <span className="exr-orange-text right-align hide-on-med-and-down show-on-large-only" style={{position:'absolute',top:'00px',left:'-20px',fontSize:'120px',fontWeight:'900'}}>+</span>
                                    <div className="row headline-text event-register-large-headline" style={{padding:'0px 20px',lineHeight:'1.25'}}>
                                        EVENT<br/>
                                        COLLECTIBLE<br/>
                                        UNLOCKED
                                    </div>
                                    <div className="row subheadline-text event-register-subheadline hide-on-med-and-down show-on-large-only" style={{fontSize:'16px',color:'silver',textTransform:'uppercase',padding:'0px 20px',lineHeight:'1.2'}}>
                                        <span id="share-reward-button" className="round-border-button event-register-formbutton exr-orange white-text" 
                                            style={{marginLeft:'0px',width:'auto',borderRadius:'5px',border:'0px'}} 
                                            title="View Event Collectible" onClick={()=>viewEventCollectible()}>
                                            <span className="left" style={{margin:"6px 5px 0px 5px"}}>VIEW NOW</span>
                                        </span>
                                    </div>
                                    <div className="row subheadline-text event-register-subheadline show-on-med-and-down hide-on-large-only" style={{fontSize:'16px',color:'silver',textTransform:'uppercase',padding:'0px 20px',lineHeight:'1.2'}}>
                                        <span id="share-reward-button" className="round-border-button event-register-formbutton exr-orange white-text left" 
                                            style={{marginLeft:'0px',width:'auto',borderRadius:'5px',border:'0px',marginLeft:'25%'}} 
                                            title="View Event Collectible" onClick={()=>viewEventCollectible()}>
                                            <span className="left" style={{margin:"6px 5px 0px 5px"}}>VIEW NOW</span>
                                        </span>
                                    </div>
                                    <div className="row subheadline-text event-register-subheadline" style={{fontSize:'16px',color:'silver',textTransform:'uppercase',padding:'0px 20px',lineHeight:'1.2'}}>
                                        <span className="white-text white-green-link" style={{margin:"6px 5px 0px 5px",marginLeft:'10px'}}
                                        onClick={()=>showWalletTransferModal()}>VIEW DETAILS</span>
                                    </div>
                                </div>
                                <div className="col s12 show-on-med-and-down hide-on-large-only" style={{color:'silver',overflow:'hidden'}}>
                                    <div className="row subheadline-text center" style={{marginTop:'10px',marginBottom:'50px',position:'relative'}} 
                                        onClick={()=>viewEventCollectible()} title="View Event Collectible">
                                        <img src="https://media.exiledracers.com/assets/banners/exr_track_meet_pool.jpg" style={{height:'70vh',borderRadius:'10px',cursor:'pointer'}} />
                                        <span className="exr-trans-black-bg-subtle" style={{position:'absolute',top:'0%',left:'0%',width:'100%',height:'100%',cursor:'pointer'}}></span>
                                        <span class="material-icons material-symbols-rounded white-text" style={{position:'absolute',top:'40%',left:'35%',fontSize:'120px',cursor:'pointer'}}>play_arrow</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="row" id="event-register-page-6" style={{display:'none',position:'relative',background:'black',width:'100vw',minHeight:'80vh',marginBottom:'0px'}}>
            
            <div className="col s12 transparent white-text" style={{position:'relative',zIndex:'10'}}>
                <div className="row firstsection" style={{marginBottom:'10px'}}>
                    <div className="col s12 m10 offset-m1 white-text">
                        <div className="row headline-text white-text event-register-large-headline" style={{lineHeight:'1.1',padding:'0px 20px'}}>
                            DJ RACE RESULTS
                        </div>
                        <div className="row headline-text exr-orange-text event-register-large-headline" style={{fontSize:'30px',lineHeight:'1.1',padding:'0px 20px'}}>
                            RACES COMPLETE - CHECK YOUR PICKS 
                        </div>
                        <div className="row" style={{marginTop:'50px',padding:'0px 20px'}}>
                            <span className="section-line-seperator white-text" style={{width:'40%',height:'2px',background:'white'}}>
                            </span>
                        </div>
                        <div className="row event-register-subheadline" style={{marginTop:'20px',marginBottom:'0px',lineHeight:'1.1',padding:'0px 20px'}}>
                            <div className="row" style={{margin:'50px 0px',lineHeight:'1.1',color:'silver'}}>
                                {racePicksHTML}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="row" id="event-register-page-7" style={{display:'none',position:'relative',width:'100vw',minHeight:'95vh'}}>
            <div id="splash-image-container" style={{width:'100vw',minHeight:'100vh',height:'100%',overflow:'hidden',position:'absolute',top:'0px',left:'0px', zIndex:'-20',background:'url('+bg_image+')',backgroundSize:'cover',backgroundPosition:'center'}}>
            </div>
            <div className="exr-trans-black-bg center-align white-text" style={{width:'100vw',minHeight:'100vh',height:'100%',position:'absolute',zIndex:'-10',top:'0px',left:'0px',padding:'20px',fontSize:'20px'}}>
            </div>
            <div className="col s12 transparent" style={{position:'relative',zIndex:'10'}}>
                <div id="splash-main-buttons">
                    <div className="row firstsection" style={{marginBottom:'10px'}}>
                        <div className="col s12 m10 offset-m1 white-text">
                            <div className="row" style={{marginTop:'30px',marginBottom:'50px',lineHeight:'1.1'}}>
                                <div className="col s12 l5 white-text">
                                    <div className="row show-on-large-only hide-on-med-and-down" style={{marginTop:'15vh'}}>
                                        <div className="left white-text" style={{width:'15%',height:'2px',background:'#FF0000'}}>
                                        </div>
                                    </div>
                                    <div className="row headline-text event-register-large-headline" style={{padding:'0px 20px'}}>
                                        CHECK THE LEADERBOARD
                                    </div>
                                    <div className="row subheadline-text event-register-subheadline section-triple-subtext" style={{fontSize:'16px',color:'silver',textTransform:'uppercase',padding:'0px 20px',lineHeight:'1.2'}}>
                                    WHERE DO YOU RANK? THE LEADERBOARD SHOWS THE POINTS EARNED FROM SPECTATOR PREDICTIONS. ANY POINTS TIES ARE TIE BROKEN BASED ON WHO PREDICTED FIRST. TOP 10 WIN REWARDS WHICH WILL DROPPED OVER THE NEXT 2 WEEKS.
                                    </div>
                                </div>
                                <div className="col s12 l7" style={{color:'silver'}}>
                                    <div className="row subheadline-text" style={{marginBottom:'50px'}}>
                                        {customLeaderboardHTML}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="row" id="event-register-page-8" style={{display:'none',position:'relative',background:'black',width:'100vw',height:'auto'}}>
            <div className="col s12 transparent" style={{position:'relative',zIndex:'10'}}>
                <div id="splash-main-buttons">
                    <div className="row center-align firstsection" style={{marginBottom:'60px'}}>
                        <div className="col s12 m10 offset-m1 white-text">
                            <div className="headline-text event-register-large-headline">
                                A WORLD'S FIRST FAN EXPERIENCE
                            </div>
                        </div>
                        <div className="col s12 m10 offset-m1 white-text">
                            <div className="subheadline-text exr-orange-text event-register-subheadline">
                                VIRTUAL DJ RACES&nbsp;
                                <span className="white-text">//</span> LIVE NYC DJ SET&nbsp;
                                <span className="white-text">//</span> PREDICTIONS&nbsp;
                                <span className="white-text">//</span> PRIZES
                            </div>
                        </div>
                    </div>
                    <div className="row center-align" style={{marginTop:'50px',marginBottom:'20px'}}>
                            <div className="col s10 offset-s1" style={{position:'relative',padding:'56% 0 0 0',position:'relative',border:'0px solid silver',height:'90vh'}}>
                                <iframe src="https://vimeo.com/event/3716343/embed" 
                                        frameborder="0" allow="autoplay; fullscreen; picture-in-picture" 
                                        style={{position:'absolute',top:'0',left:'0',width:'100%',height:'90vh'}}>
                                </iframe>
                            </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="row exr-stats-light-grey" id="event-register-page-9" style={{display:'none',position:'relative',minWidth:'100vw',minHeight:'80vh'}}>
            <div className="col s12 transparent" style={{position:'relative',zIndex:'10'}}>
                <div id="splash-main-buttons">
                    <div className="row center-align firstsection" style={{marginBottom:'10px'}}>
                        <div className="col s12 m10 offset-m1 white-text">
                            <div className="row black-text" style={{margin:'0px',padding:'0px',marginTop:'30px'}}>
                                <span className="headline-text black-text event-register-large-headline" style={{padding:'10px 20px',borderBottom:'2px solid silver'}}>
                                    SUPPORTED BY
                                </span>
                            </div>
                            <div className="row black-text" style={{margin:'0px',padding:'0px',marginTop:'80px',marginBottom:'50px',lineHeight:'1.1'}}>
                                <div className="col s12 m12 l4" style={{margin:'0px',padding:'0px'}}>
                                    <div className="left" style={{width:'100%',padding:'30px'}}>
                                        <div className="row headline-text" style={{fontSize:'18px',padding:'0px',marginBottom:'30px'}}>
                                            GAME SPONSOR
                                        </div>
                                        <div className="row" style={{padding:'0px',height:'100px'}}>
                                            <a href="https://www.exiledracers.com/" target="_blank" title="Exiled Racers">
                                                <img src={logo_image} style={{height:'70px'}} />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col s12 m6 l4" style={{margin:'0px',padding:'0px'}}>
                                    <div className="left" style={{width:'100%',padding:'30px'}}>
                                        <div className="row headline-text" style={{fontSize:'18px',padding:'0px',marginBottom:'30px'}}>
                                            PLATFORM SPONSORS
                                        </div>
                                        <div className="row" style={{padding:'0px',height:'100px'}}>
                                            <a href="https://www.polkadot.network/" target="_blank" title="Polkadot Network">
                                                <img src={polka_logo} style={{height:'70px',marginRight:'30px'}} />
                                            </a>
                                            <a href="https://moonbeam.network/" target="_blank" title="Moonbeam Network">
                                                <img src={moonbeam_logo} style={{height:'70px'}} />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col s12 m6 l4" style={{margin:'0px',padding:'0px'}}>
                                    <div className="left" style={{width:'100%',padding:'30px'}}>
                                        <div className="row headline-text" style={{fontSize:'18px',padding:'0px',marginBottom:'30px'}}>
                                            PREDICTION PARTNER
                                        </div>
                                        <div className="row" style={{padding:'0px',height:'100px'}}>
                                            <a href="https://zeitgeist.pm/" target="_blank" title="Zeitgeist">
                                                <img src={ztg_logo} style={{height:'70px'}} />
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="col s12" style={{margin:'0px',padding:'0px'}}>
                                    <div className="left" style={{width:'100%',padding:'30px'}}>
                                        <div className="row headline-text" style={{fontSize:'18px',padding:'0px',marginBottom:'40px'}}>
                                            COMMUNITY PARTNERS
                                        </div>
                                        <div className="row" style={{padding:'0px',height:'100px'}}>
                                            <div className="col s12 m4 l3 left center-align" style={{margin:'0px',padding:'0px',marginBottom:'20px',height:'60px'}}>
                                                <a href="https://www.mufi.app/" target="_blank" title="MuFi">
                                                    <img src="https://media.exiledracers.com/partners/mufi_logo.png" style={{marginTop:'0px',height:'35px'}} />
                                                </a>
                                            </div>
                                            <div className="col s12 m4 l3 left center-align" style={{margin:'0px',padding:'0px',marginBottom:'20px',height:'60px'}}>
                                                <a href="https://www.dega.org/" target="_blank" title="Dega">
                                                    <img src="https://media.exiledracers.com/partners/dega_logo.png" style={{marginTop:'-5px',height:'50px'}} />
                                                </a>
                                            </div>
                                            
                                            <div className="col s12 m4 l3 left center-align" style={{margin:'0px',padding:'0px',marginBottom:'20px',height:'60px'}}>
                                                <a href="https://astar.network/" target="_blank" title="Astar Network">
                                                    <img src="https://media.exiledracers.com/partners/astar_logo.png" style={{height:'45px'}} />
                                                </a>
                                            </div>
                                            <div className="col s12 m4 l3 left center-align" style={{margin:'0px',padding:'0px',marginBottom:'20px',height:'60px'}}>
                                                <a href="https://web3auth.io/" target="_blank" title="Web3Auth">
                                                    <img src="https://media.exiledracers.com/partners/web3auth_logo.svg" style={{height:'30px',marginTop:'5px'}} />
                                                </a>
                                            </div>
                                            <div className="col s12 m4 l3 left center-align" style={{margin:'0px',padding:'0px',marginBottom:'20px',height:'60px'}}>
                                                <a href="https://www.biconomy.io/" target="_blank" title="Biconomy">
                                                    <img src="https://media.exiledracers.com/partners/biconomy_logo.svg" style={{height:'35px'}} />
                                                </a>
                                            </div>
                                            <div className="col s12 m4 l3 left center-align" style={{margin:'0px',padding:'0px',marginBottom:'20px',height:'60px'}}>
                                                <a href="https://oak.tech/" target="_blank" title="Oak Network">
                                                    <img src="https://media.exiledracers.com/partners/oak_logo.png" style={{height:'45px'}} />
                                                </a>
                                            </div>
                                            <div className="col s12 m4 l3 left center-align" style={{margin:'0px',padding:'0px',marginBottom:'20px',height:'60px'}}>
                                                <a href="https://stellaswap.com/" target="_blank" title="Stellaswap">
                                                    <img src="https://media.exiledracers.com/partners/stellaswap_logo.png" style={{height:'42px'}} />
                                                </a>
                                            </div>
                                            <div className="col s12 m4 l3 left center-align" style={{margin:'0px',padding:'0px',marginBottom:'20px',height:'60px'}}>
                                                <a href="https://manta.network/" target="_blank" title="Manta Network">
                                                    <img src="https://media.exiledracers.com/partners/manta_logo.png" style={{marginTop:'-2px',height:'40px'}} />
                                                </a>
                                            </div>
                                            <div className="col s12 m4 l3 left center-align" style={{margin:'0px',padding:'0px',marginBottom:'20px',height:'60px'}}>
                                                <a href="https://axelar.network/" target="_blank" title="Axelar">
                                                    <img src="https://media.exiledracers.com/partners/axelar_logo.png" style={{height:'35px'}} />
                                                </a>
                                            </div>
                                            <div className="col s12 m4 l3 left center-align" style={{margin:'0px',padding:'0px',marginBottom:'20px',height:'60px'}}>
                                                <a href="https://www.primeprotocol.xyz/" target="_blank" title="Prime Protocol">
                                                    <img src="https://media.exiledracers.com/partners/prime_protocol_logo.png" style={{marginTop:'-5px',height:'45px'}} />
                                                </a>
                                            </div>
                                            <div className="col s12 m4 l3 left center-align" style={{margin:'0px',padding:'0px',marginBottom:'20px',height:'60px'}}>
                                                <a href="https://dam.finance/" target="_blank" title="Dam Finance">
                                                    <img src="https://media.exiledracers.com/partners/dam_logo.svg" style={{marginTop:'-2px',height:'37px'}} />
                                                </a>
                                            </div>
                                            <div className="col s12 m4 l3 left center-align" style={{margin:'0px',padding:'0px',marginBottom:'20px',height:'60px'}}>
                                                <a href="https://moonwell.fi/" target="_blank" title="Moonwell">
                                                    <img src="https://media.exiledracers.com/partners/moonwell_logo.svg" style={{marginTop:'5px',height:'28px'}} />
                                                </a>
                                            </div>

                                            
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div id="rewards_content_show" className="modal page-modal page-modal-media center" style={{lineHeight:'0',borderRadius:'10px',overflow:'hidden'}}>
            <video id="rewards-video" src="https://media.exiledracers.com/assets/passes/exr_track_meet_collectible_nft.mp4#t=0.9" 
                controls="true" style={{padding:'0px',margin:'0px',borderRadius:'10px'}} />
        </div>
        {rewardsTransferBoxHTML}
        <div id="rewards_transfer" className="modal page-modal page-modal-medium page-modal-tall" style={{lineHeight:'0',borderRadius:'10px',overflow:'hidden'}}>
            <div className="modal-content">
                <div className="row" style={{marginBottom:'5px',position:'relative'}}>
                    <div className="round-close-button" style={{right:'-10px'}} title="Close" onClick={()=>closeAllModals()}>
                        X
                    </div>
                    <div className="col s12" style={{fontSize:"24px",marginTop:"0px",padding:"0px"}}>
                        <div className="left headline-text" style={{marginLeft:'5px'}}>EXR COLLECTIBLES</div>
                    </div>
                    <div className="col s12" style={{padding:"0px 5px"}}>
                        <div className="divider-thin"></div>
                    </div>
                    <div className="col s12" style={{fontSize:"16px",marginTop:"10px",padding:"0px"}}>
                        <div className="left subheadline-text" style={{marginLeft:'5px'}}>
                            Congrats! You have unlocked an EXR Digital Collectible. Digital Collectibles are ways for you to keep a piece of a race, event or moment forever. 
                            Check out the details and manage your collectible below.
                        </div>
                    </div>
                    <div className="col s12 m4 show-on-med-and-up hide-on-small-only" style={{fontSize:"18px",marginTop:"0px",padding:"20px"}}>
                        {rewardTransferBoxMedia}
                    </div>
                    <div className="col s12 m8" style={{fontSize:"16px",marginTop:"0px",padding:"20px"}}>
                        <div className="row" style={{padding:'0px',marginBottom:'0px',marginTop:'10px'}}>
                            <div className="left subheadline-text exr-light-green-text" style={{marginLeft:'5px',fontSize:'14px'}}>VIDEO EVENT COLLECTIBLE</div>
                        </div>
                        <div className="row" style={{padding:'0px',marginBottom:'0px'}}>
                            <div className="left headline-text" style={{marginLeft:'5px',fontSize:'20px'}}>EXR TRACK MEET '23</div>
                        </div>
                        <div className="row" style={{padding:'0px',marginBottom:'0px',marginTop:'10px'}}>
                            <div className="divider-thin"></div>
                        </div>
                        <div className="row" style={{display:'flex',flexDirection:'row',padding:'10px',marginBottom:'0px'}}>
                                Sent to {rewardWalletName}:<br/>
                                {rewardWalletAddress}
                        </div>
                        <div className="row" style={{padding:'0px',marginBottom:'10px'}}>
                            <div className="divider-thin"></div>
                        </div>

                        <div id="rewardtransferstart" className="row" title="Save Account Settings" style={{marginTop:'20px'}}>
                            <span className="right round-border-button event-register-formbutton exr-orange white-text" 
                                style={{width:'auto',marginLeft:'0px',borderRadius:'5px',border:'0px',height:'35px'}} 
                                title="VIEW IN WALLET" onClick={()=>showWalletMoonscan()}>
                                <span className="right" style={{margin:"6px 5px 0px 5px",fontSize:'16px'}}>VIEW IN WALLET</span>
                            </span>
                            <span id="manageRewardButton" className="right white-text" 
                                style={{display:'none',width:'100%',marginLeft:'0px',borderRadius:'5px',border:'0px',height:'35px',marginTop:'10px'}} 
                                title="Manage Collectible" onClick={()=>transferStart()}>
                                <span className="right white-green-link" style={{margin:"6px 5px 0px 5px",fontSize:'14px'}}>MANAGE ITEM</span>
                            </span>
                        </div>
                        <div id="rewardtransfernewwallet" className="row" style={{padding:'10px',marginBottom:'10px',display:'none'}}>
                                Transfer to Wallet Address:&nbsp;&nbsp;<br/>
                                <input id="personalWalletAddress" 
                                        type="text" 
                                        className="browser-default light-grey-bubble-input"
                                        style={{width:'100%'}} />
                        </div>
                        <div id="rewardtransfercode" className="row" style={{padding:'10px',marginBottom:'10px',display:'none'}}>
                                Email Code:&nbsp;&nbsp;<br/>
                                <input id="transferEmailCode" 
                                    type="text" 
                                    className="browser-default light-grey-bubble-input" 
                                    style={{width:'100%'}} />
                        </div>
                        <div id="rewardtransferdivider" className="row" style={{display:'none',padding:'0px',marginBottom:'20px'}}>
                            <div className="divider-thin"></div>
                        </div>
                        <div id="rewardtransferconfirm" className="row" title="Confirm Wallet Transfer" style={{display:'none'}}>
                            <span className="right round-border-button event-register-formbutton exr-orange white-text" 
                                style={{marginLeft:'0px',width:'auto',borderRadius:'5px',border:'0px',height:'35px'}} 
                                title="View Event Collectible" onClick={()=>transferEmailCodeSent()}>
                                <span className="left" style={{margin:"6px 5px 0px 5px",fontSize:'16px'}}>NEXT</span>
                            </span>
                        </div>
                        <div id="rewardtransfersubmit" className="row" title="Complete Transfer" style={{display:'none'}}>
                            {rewardTransferHiddenVars}

                            <span className="right round-border-button event-register-formbutton exr-orange white-text" 
                                style={{marginLeft:'0px',width:'auto',borderRadius:'5px',border:'0px',height:'35px'}} 
                                title="View Event Collectible" onClick={()=>completeTransfer()}>
                                <span className="left" style={{margin:"6px 5px 0px 5px",fontSize:'16px'}}>CONFIRM TRANSFER</span>
                            </span>
                        </div>
                        <div id="rewardtransferloading" className="row" title="Transfer Completed" style={{display:'none'}}>
                            <div className="preloader-wrapper small active right" style={{height:'30px',width:'30px',marginTop:'3px'}}>
                                <div className="spinner-layer spinner-red-only">
                                    <div className="circle-clipper left">
                                        <div className="circle"></div>
                                    </div>
                                    <div className="gap-patch">
                                        <div className="circle"></div>
                                    </div>
                                    <div className="circle-clipper right">
                                        <div className="circle"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div id="rewardtransfercomplete" className="row" title="Transfer Completed" style={{display:'none'}}>
                            <span className="right round-border-button event-register-formbutton exr-light-green black-text" 
                                style={{marginLeft:'0px',width:'auto',borderRadius:'5px',border:'0px',height:'35px'}} 
                                title="View Event Collectible">
                                <span className="left" style={{margin:"6px 5px 0px 5px",fontSize:'16px'}}>TRANSFER COMPLETE</span>
                            </span>
                        </div>
                        <div id="rewardtransfercancel" className="row" title="Cancel Transaction" style={{display:'none',marginTop:'-10px'}}>
                            <span className="right white-text white-green-link" style={{margin:"6px 5px 0px 5px",marginLeft:'10px'}}
                                        onClick={()=>cancelTransfer()}>CANCEL</span>
                        </div>
                    </div>
                    <div className="col s12 m4 show-on-small-only hide-on-med-and-up" style={{fontSize:"18px",marginTop:"0px",padding:"20px"}}>
                        {rewardTransferBoxMedia}
                    </div>
                </div>
            </div>
        </div>
    </div>);
};